var preProcessingData = {
	pssqlGeojson: function(array, geometry_key){
		var geo_container = { type: "FeatureCollection", features: [] }
		array.forEach(function(each){
			var this_feature = {"type": "Feature", "properties":{}, "geometry": JSON.parse(each[geometry_key])}
			Object.keys(each).forEach(function(key){
				if (key != geometry_key) { this_feature.properties[key] = each[key] }
			})
			geo_container.features.push(this_feature)
		})
		return geo_container
	}
}

function leafletExtendTileHandle(){
	var layerList = ['通用版電子地圖透明', '鄉區界', '村里界', '段籍圖', '國土利用調查成果圖']
	layerList.forEach(el => {
		if (map.hasLayer(overlayMaps[el])) {
			map.removeLayer(overlayMaps[el])
			setTimeout(function(){
				overlayMaps[el].addTo(map)
			}, 1000)
		}
	})
}

function toast_open(html_string, source_unit = ''){
    var new_toast_object = $(
		`<div class="card mt-2 shadow-lg">
			<h5 class="card-header pt-1 pb-1 font-weight-bold bg-danger text-white"><i class="fas fa-info-circle mr-2"></i>系統通知</h5>
			<div class="card-body">
				<p class="card-text">${html_string}</p>
				${ source_unit == '' ? '' : `<p class="card-text">資料來源：${source_unit}</p>` }
			</div>
		</div>`
	).appendTo('#toast_container');
    setTimeout(function(){
    	new_toast_object.remove();
    }, 3000);
}

function ajaxErrorHandle(e){
	if(e.statusText == "UNAUTHORIZED" || e.statusText == "unauthorized" || e.statusText == "Unprocessable Entity"){
		alert("單次登入使用期限到期，請重新登入！")
		$("#t_logout").click()
	}
	if (e.statusText == "Internal Server Error") {
		toast_open("API介接異常")
	}
}

function ajax_call(url){
	var result = null;
	var scriptUrl = url;
	$.ajax({
		url: scriptUrl,
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		type: 'get',
		dataType: 'json',
		async: false,
		timeout: 15000,
		success: function(data) {
		    result = data;
		},
		error: function(e){
			let errorMessage = "API介接資料異常！";
			if (e.responseJSON && e.responseJSON.message) {
				errorMessage = e.responseJSON.message; // 使用後端返回的錯誤訊息
			}
			var source_unit = ''
			if (url.includes("emis")) {
				source_unit = 'EMIS(消防局整備科)'
			}
			if (url.includes("cwb")) {
				source_unit = '中央氣象署'
			}
			if (url.includes("ncdr")) {
				source_unit = 'NCDR'
			}
			toast_open(errorMessage, source_unit);
			ajaxErrorHandle(e);
		}
	});
	return result;
}

function ajax_call_async(url, success_call_back, error_call_back){
	var scriptUrl = url;
	$.ajax({
		url: scriptUrl,
		type: 'get',
		dataType: 'json',
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		success: function(data) {
		    success_call_back(data);
		},
		error: function(e){
			let errorMessage = "API介接資料異常！";
			if (e.responseJSON && e.responseJSON.message) {
				errorMessage = e.responseJSON.message; // 使用後端返回的錯誤訊息
			}
			var source_unit = ''
			if (url.includes("emis")) {
				source_unit = 'EMIS(消防局整備科)'
			}
			if (url.includes("cwb")) {
				source_unit = '中央氣象署'
			}
			if (url.includes("ncdr")) {
				source_unit = 'NCDR'
			}
			toast_open(errorMessage, source_unit);
			error_call_back();
			ajaxErrorHandle(e)
		}
	});
}

function render_block_spinner(target_array){
	target_array.forEach(function(each){
		$(each).html('<div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div>')
	})
}

function ajax_call_datatype(url, datatype){
	var result = null;
	var scriptUrl = url;
	$.ajax({
		url: scriptUrl,
		type: 'get',
		dataType: datatype,
		async: false,
		success: function(data) {
		    result = data;
		}
	});
	return result;
}

function ajax_call_post(url, data_request){
	var result = null;
	var scriptUrl = url;
	$.ajax({
		url: scriptUrl,
		type: 'post',
		dataType: 'json',
		data: data_request,
		async: false,
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		success: function(data) {
		    result = data;
		}
	});
	return result;
}

function ajax_call_post_async(url, data_request, success_call_back, error_call_back){
	var scriptUrl = url;
	$.ajax({
		url: scriptUrl,
		type: 'post',
		dataType: 'json',
		data: data_request,
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		success: function(data) {
		    success_call_back(data);
		},
		error: function(e){
			let errorMessage = "API介接資料異常！";
			if (e.responseJSON && e.responseJSON.message) {
				errorMessage = e.responseJSON.message; // 使用後端返回的錯誤訊息
			}
			toast_open(errorMessage);
			error_call_back();
			ajaxErrorHandle(e)
		}
	});
}

function ajax_call_xml(url){
	var result = null;
	var scriptUrl = url;
	$.ajax({
		url: scriptUrl,
		type: 'get',
		dataType: 'xml',
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		async: false,
		success: function(data) {
		    result = data;
		}
	});
	return result;
}

function isInteger(obj) {
    return parseInt(obj, 10) === obj
}

function ajax_call_html(url){
	var result = null;
	var scriptUrl = url;
	$.ajax({
		url: scriptUrl,
		type: 'get',
		dataType: 'html',
		async: false,
		success: function(data) {
		    result = data;
		}
	});
	return result;
}

function highchart_reflow(){
	Highcharts.charts.forEach(function(chart) {
		try {
			if (chart == undefined) {

			} else {
				chart.reflow();
			}
		} catch (e) {

		}
	});
}

function showTime(){
	var today = new Date();
	var hour=
	parseInt(today.getHours())<10
	? '0'+today.getHours()
	: today.getHours();
	var min=
	parseInt(today.getMinutes())<10
	? '0'+today.getMinutes()
	: today.getMinutes();
	var sec=
	parseInt(today.getSeconds())<10
	? '0'+today.getSeconds()
	: today.getSeconds();
	document.getElementById('nowtime').innerHTML=' '+ hour+':'+min+':'+sec
}

function time_sql_processing(value){
	var result,
		year = parseInt(value.slice(0,4)),
		month = parseInt(value.slice(5,7))-1,
		date = parseInt(value.slice(8,10)),
		hour = parseInt(value.slice(11,13)),
		min = parseInt(value.slice(14,16));
	result = Date.UTC(year, month, date, hour, min);
	return result;
}

function time_sql_processing_version2(value){
	var result,
		year = parseInt(value.slice(0,4)),
		month = parseInt(value.slice(4,6))-1,
		date = parseInt(value.slice(6,8)),
		hour = parseInt(value.slice(8,10)),
		min = parseInt(value.slice(10,12));
	var result = Date.UTC(year, month, date, hour, min);
	return result;
}

function time_sql_processing_date(value){
	var result,
		year = parseInt(value.slice(0,4)),
		month = parseInt(value.slice(5,7))-1,
		date = parseInt(value.slice(8,10));
	result = Date.UTC(year, month, date);
	return result;
}

function time_sql_stringVersion(value){
	var data = value.split(" ");
	var date_string = data[0].split("-"), time_string = data[1];
	var result,
	year = parseInt(date_string[2]),
	month = parseInt(month_str2_value(date_string[1]))-1,
	date = parseInt(date_string[0]),
	hour = parseInt(time_string.slice(0,2)),
	min = parseInt(time_string.slice(3,5));
	result = Date.UTC(year, month, date, hour, min);
	return result;
}

function timeConverter_stringVersion(value){
	var data = value.split(" ");
	var date_string = data[0].split("-"), time_string = data[1];
	var result,
	year = date_string[2],
	month = time_string_processing(month_str2_value(date_string[1])),
	date = date_string[0],
	hour = time_string.slice(0,2),
	min = time_string.slice(3,5);
	result = year + "/" + month + "/" + date + " " + hour + ":" + min;
	return result;
}

function month_str2_value(value){
	var result;
	switch(value){
		case "Jan":
			result = 1;
			break;
		case "Feb":
			result = 2;
			break;
		case "Mar":
			result = 3;
			break;
		case "Apr":
			result = 4;
			break;
		case "May":
			result = 5;
			break;
		case "Jun":
			result = 6;
			break;
		case "Jul":
			result = 7;
			break;
		case "Aug":
			result = 8;
			break;
		case "Sep":
			result = 9;
			break;
		case "Oct":
			result = 10;
			break;
		case "Nov":
			result = 11;
			break;
		case "Dec":
			result = 12;
			break;
	}
	return result;
}

function event_fire_time_processing(value){
	var result = value
	try {
		if (result.match("1900")) {
			result = "-"
		}
	} catch(e) {
		result = "-"
	}
	return result
}

function event_time_processing(value){
	value = String(value)
	var result,
		year = parseInt(value.slice(0,4)),
		month = parseInt(value.slice(4,6))-1,
		date = parseInt(value.slice(6,8)),
		hour = parseInt(value.slice(8,10)),
		result = Date.UTC(year, month, date, hour);
	return result;
}

function time_sql_processing_community_obs(value){
	var result,
	year = parseInt(value.slice(0,4)),
	month = parseInt(value.slice(4,6))-1,
	date = parseInt(value.slice(6,8)),
	hour = parseInt(value.slice(8,10)),
	min = parseInt(value.slice(10,12)),
	sec = parseInt(value.slice(12,14))
	result = Date.UTC(year, month, date, hour, min, sec);
	return result;
}

function get_now_time_object(){
	var day_prototype = new Date();
	var year = day_prototype.getFullYear();
	var month = day_prototype.getMonth()+1;
	var date = day_prototype.getDate();
	var hour = day_prototype.getHours();
	var result = {
		"year": year,
		"month": month,
		"date": date,
		"hour": hour
	};
	return result;
}

function get_now_time_UTC(){
	var day_prototype = new Date();
	var year = day_prototype.getFullYear();
	var month = day_prototype.getMonth()+1;
	var date = day_prototype.getDate();
	var hour = day_prototype.getHours();
	var result = time_sql_processing(year + "-" + time_string_processing(month) + "-" + time_string_processing(date) + " " + time_string_processing(hour) + ":00:00");
	return result;
}

function get_now_time_utc_value(){
	var today = new Date(), result = "";
	var year = parseInt(today.getFullYear())
	var month =
		parseInt(today.getMonth()+1)<10
		? '0'+(today.getMonth()+1)
		: today.getMonth()+1;
	var date =
		parseInt(today.getDate())<10
		? '0'+today.getDate()
		: today.getDate();
	var hour =
		parseInt(today.getHours())<10
		? '0'+today.getHours()
		: today.getHours();
	var min =
		parseInt(today.getMinutes())<10
		? '0'+today.getMinutes()
		: today.getMinutes();
	var sec =
		parseInt(today.getSeconds())<10
		? '0'+today.getSeconds()
		: today.getSeconds();
	result = Date.UTC(year, month-1, date, hour, min, sec);
	return result;
}

function timeConverter(value){
	var value = String(value);
	var result,
	year = value.slice(0,4),
	month = value.slice(4,6),
	date = value.slice(6,8),
	hour = value.slice(8,10),
	min = value.slice(10,12)
	result = year + "/" + month + "/" + date + " " + hour + ":" + min;
	return result;
}

function ntu2d_time_converter(input){
	var result,
	year = parseInt(input.slice(0,4)),
	month = parseInt(input.slice(4,6))-1,
	date = parseInt(input.slice(6,8)),
	hour = parseInt(input.slice(8,10))+8;
	result = UTCtoString(Date.UTC(year, month, date, hour)).split(" ");
	result = result[3] + "/" + time_string_processing(month_str2_value(result[2])) + "/" + result[1] + " " + result[4].slice(0, 5);
	return result;
}

function ntu2d_time_converter_48hr_range(input){
	var result,
	year = parseInt(input.slice(0,4)),
	month = parseInt(input.slice(4,6))-1,
	date = parseInt(input.slice(6,8)),
	hour = parseInt(input.slice(8,10))+56;
	result = UTCtoString(Date.UTC(year, month, date, hour)).split(" ");
	result = result[3] + "/" + time_string_processing(month_str2_value(result[2])) + "/" + result[1] + " " + result[4].slice(0, 5);
	return result;
}

function UTCtoString(value){
	var result = new Date(value);
	result = result.toUTCString();
	return result;
}

function UTCtoString_v2(value){
	var today = new Date(value),
		result,
		year = parseInt(today.getFullYear())
	var month =
		parseInt(today.getMonth()+1)<10
		? '0'+(today.getMonth()+1)
		: today.getMonth()+1;
	var date =
		parseInt(today.getDate())<10
		? '0'+today.getDate()
		: today.getDate();
	var hour =
		parseInt(today.getHours())<10
		? '0'+today.getHours()
		: today.getHours();
	var min =
		parseInt(today.getMinutes())<10
		? '0'+today.getMinutes()
		: today.getMinutes();
	result = year + "/" + month + "/" + date + " " + hour + ":" + min;
	return result;
}

function sql_query_start_time(value){
	if (!value) return
	function time_fixed(ans){
		if (ans.length == 1 ) {
			ans = "0" + ans;
		}
		return ans;
	}
	var d = new Date(value.slice(0,4), parseInt(value.slice(5,7))-1, value.slice(8,10), value.slice(11,13));
	d.setTime(d.getTime()-24*60*60*1000*2);
	var year =  String(d.getFullYear()),
		month =  time_fixed(String(d.getMonth()+1)),
		date =  time_fixed(String(d.getDate())),
		hour =  time_fixed(String(d.getHours()));
	var start_time = year + "-" + month + "-" + date + "T" + hour + ":00:00";
	return start_time;
}

function get_time_string(input){
	var day_prototype = new Date();
	day_prototype.setHours(day_prototype.getHours() - input);
	var year = day_prototype.getFullYear();
	var month = day_prototype.getMonth()+1;
	var date = day_prototype.getDate();
	var hour = day_prototype.getHours();
	var result = year + "-" + time_string_processing(month) + "-" + time_string_processing(date) + " " + time_string_processing(hour) + ":00:00";
	return result;
}

function get_time_string_v2(input){
	var day_prototype = new Date();
	day_prototype.setHours(day_prototype.getHours() - input);
	var year = day_prototype.getFullYear();
	var month = day_prototype.getMonth()+1;
	var date = day_prototype.getDate();
	var hour = day_prototype.getHours();
	var result = {
		"month": month,
		"date": date
	};
	return result;
}

function undefined_converter(value){
	var result;
	if(value == null || value == undefined){
		result = "";
	} else{
		result = value;
	}
	return result;
}

function null_Converter(value){
	var result;
	if(value == null || value == "None"){
		result = "-";
	} else{
		result = value;
	}
	return result;
}

function null_Converter_v2(value){
	var result;
	if(value == null || value == "null" || value == "NULL" || value == "" || value == "NaN"){
		result = "-";
	} else {
		result = value;
	}
	return result;
}

function null_Converter_v3(value){
	var result;
	if(value == null || value == "null" || value == "NULL" || value == ""){
		result = "-";
	} else {
		result = value;
	}
	return result;
}

function time_string_processing(input){
	if (input < 10) {
		input = "0" + input;
	}
	return input;
}

function NTC_map(){
	var result = null;
	var scriptUrl = 'geojson/NTC.json';
	$.ajax({
		url: scriptUrl,
		type: 'get',
		dataType: 'json',
		async: false,
		success: function(data) {
			result = data;
		}
	});
	return result;
}

function backgroud_layer_control(string_value, close_boolean){
	$(".scale_target").each(function(){
		var string = $(this).find("td").eq(3).html();
		if (string == string_value) {
			if (close_boolean == "close") {
				if ($(this).find("input").prop('checked')) {
					$(this).click();
				}
			} else {
				if (!$(this).find("input").prop('checked')) {
					$(this).click();
				}
			}
		}
	});
}

function layer_remove(){
	try {
		$(".scale_target").each(function(){
			if ($(this).find("input").prop('checked')) {
				var layer_name = $(this).find("td").eq(3).html();
				$(this).find("input").prop('checked', false);
				if (overlay_dataset[layer_name] != undefined) {
					map.removeLayer(overlay_dataset[layer_name]);
				}
			}
		})
		Object.keys(overlay_dataset).forEach(el => {
			if (map.hasLayer(overlay_dataset[el])) {
				map.removeLayer(overlay_dataset[el])
			}
		})
		$(".topic-layer-control").each(function(){
			$(this).val("close")
		})
	} catch(e) {
		return
	}
}

function modal_open(html_string, title, callBack){
	if (!title) { title = "進階資訊檢視" }
	$("#event_modal .modal-title").html(title)
	$('#event_modal').modal({})
	$("#event_container").empty()
	setTimeout(function(){
		$("#event_container").html(html_string)
		if (callBack) {
			callBack()
		}
	}, 1000)
}

function modal_event_flex_open(html_string){
	$('#event_flex_modal').modal({});
	setTimeout(function(){
		$("#event_flex_container").html(html_string);
	}, 1000);
}

function modal_open_table(title_string, thead_string, tbody_string, order, tfoot_string = ''){
	$('#event_modal').modal({});
	$("#event_container").empty();
	$("#event_modal .modal-title").html(title_string)
	var html_string =
		'<table class="table table-sm table-hover" id="board_table" width="100%" height="100%">' +
			'<thead class="thead-dark">' +
				'<tr>' +
					thead_string +
				'</tr>' +
			'</thead>' +
			'<tbody>' +
				tbody_string +
			'</tbody>' +
			'<tfoot>' +
				tfoot_string +
			'</tfoot>' +
		'</table>';
	setTimeout(function(){
		$("#event_container").html(html_string);
		$('#board_table').DataTable({
            "order": [[ order, "desc" ]],
            "paging": false
        });
	}, 1000);
}

function loader_asynchronous(function_code){
	loader_animation_control(true);
	setTimeout(function(){
		function_code();
		loader_animation_control(false);
	}, 100)
}

function loader_animation_control(boolean){
	switch(boolean){
		case true:
			$("#loader_animation").css("display", "block");
			break;
		case false:
			$("#loader_animation").css("display", "none");
			break;
	}
}

function board_col_12(){
    var board_html = $('#board_list .row').detach();
	if (board_html.find(".col-6").length > 0) {
    	board_html.find(".col-6").each(function(){
    		$(this).removeClass("col-6");
    		$(this).addClass("col-12");
    	})
	}
	$('#board_list').append('<div class="row"></div>');
	$('#board_list').append(board_html);
}

function report_col_control(find, changeTo){
	$('#event_info_div .row').find("." + find).each(function(){
		$(this).removeClass(find);
		$(this).addClass(changeTo);
	})
}

function value_catch_error(input){
	var result;
	try{
		result = input;
	} catch(e){
		result = null;
	}
	return result;
}

function layer_table_redraw(){
    var table = $('#ovarlay_list').DataTable().search("").draw();
}

function slider_card_component_create(input, default_open = true){
	var html_string =
		'<div class="w-100">'+
			'<div class="slider-card-head p-2 w-100">'+
				'<h5 class="font-weight-bold mb-1"><span class="slider-card-head-dot"></span>'
				+ input.cardhead + `<i class="fas ${default_open ? 'fa-angle-down' : 'fa-angle-up'} float-right mt-1"></i></h5>` +
	        '</div>'+
	        `<div class="slider-card-content ${default_open ? '' : 'd-none'}">`+
				'<div class="row p-2">'+
					input.cardbody +
				'</div>'+
	        '</div>' +
	    '</div>';
	return html_string;
}

function data_source_table_html(name) {
	const data = ajax_call("geojson/data_source_table.json")

	let table_body = '';
	data[name].forEach((item) => {
		table_body += `<tr>
			<td>${item.name}</td>
			<td>${item.source_unit}</td>
			<td>${item.contact}</td>
			<td>${item.phone}</td>
		</tr>`;
	});

	let html = `<table class="table table-sm table-hover" width="100%" height="100%">
		<thead class="thead-dark">
			<tr>
				<th>資料名稱</th>
				<th>來源單位</th>
				<th>聯絡人</th>
				<th>聯絡電話</th>
			</tr>
		</thead>
		<tbody>
			${table_body}
		</tbody>
	</table>`;


	return `<div class="col-12">${html}</div>`
}

function highchart_two_panes_series_plot(input){
	Highcharts.stockChart(input.div, {
		chart: {
			zoomType: 'x',
		},
		rangeSelector: {
			enabled: false
		},
		navigator: {
			enabled: false
		},
		scrollbar: {
			enabled: false
		},
		title: {
			text: input.title
		},
		yAxis: [{
			labels: {
			  	align: 'right',
			  	x: -3
			},
			title: {
			  	text: input.series.label_name[0]
			},
			height: '50%',
			lineWidth: 2,
			resize: {
			  	enabled: true
			}
			}, {
			labels: {
			  	align: 'right',
			  	x: -3
			},
			title: {
		  		text: input.series.label_name[1]
			},
			top: '50%',
			height: '50%',
			offset: 0,
			lineWidth: 2,
			plotLines: input.critical_line
		}],
		tooltip: {
			split: true
		},
		series: [{
				type: 'column',
				name: input.series.series_name[0],
				data: input.series.data[0],
				tooltip: { valueDecimals: 2}
			}, {
				type: 'spline',
				name: input.series.series_name[1],
				data: input.series.data[1],
				yAxis: 1,
				tooltip: { valueDecimals: 2}
		}]
	});
}

function prediction_normal_info(){
	$("#prediction_info").html(
		'<div class="input-group mb-2 pb-2 border-b-normal">'+
		  	'<div class="input-group-prepend">'+
		    	'<label class="input-group-text">選擇預測類型</label>'+
		  	'</div>'+
		  	'<select class="custom-select" id="prediction_type">'+
			  	'<option value="ai_rain">降雨預測模組</option>'+
				'<option value="afternoon_rain">午後雷陣雨預測</option>'+
				'<option value="roadflood">地面淹水預測&抽水機調度</option>'+
		  		'<option value="hillslope">坡地災情預測</option>'+
				'<option value="electricity">颱洪停電風險地圖</option>'+
				'<option value="mountflood">山區閃洪&平地淹水預測</option>'+
				'<option class="d-none" value="flood">積淹水災情預測</option>'+
			'</select>'+
		'</div>'
	);
	$("#prediction_type").change(function(){
		$(".sub-group").each(function(){
			if (!$(this).hasClass("d-none")) {
				$(this).toggleClass("d-none")
			}
		})
		let target = $(this).val()
		$("#prediction_" + target).toggleClass("d-none")
		switch (target) {
			case "ai_rain":
				loader_asynchronous(prediction_ai_rain)
				break
			case "afternoon_rain":
				loader_asynchronous(prediction_afternoon_rain)
				break
			case "roadflood":
				loader_asynchronous(prediction_roadflood)
				break
			case "hillslope":
				loader_asynchronous(prediction_hillslope)
				break
			case "electricity":
				loader_asynchronous(prediction_electricity)
				break
			case "mountflood":
				loader_asynchronous(prediction_mountflood)
				break
		}
	}).trigger("change")
}

function coor_transformation(array){
	proj4.defs([
		[
		   'EPSG:4326',
		   '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'],
		[
		   'EPSG:3826',
		   '+title=TWD97 TM2+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +units=公尺 +no_defs']
	]);
	var EPSG3826 = new proj4.Proj('EPSG:3826');
	var EPSG4326 = new proj4.Proj('EPSG:4326');
	var result = proj4(EPSG3826, EPSG4326, array);
	return result;
}

function ascii_to_geojson(data){
	var string_array = data.split("\n");
	var cols = string_array[0].split("ncols")[1].trim(),
		rows = string_array[1].split("nrows")[1].trim(),
		xllcorner = parseFloat(string_array[2].split("xllcorner")[1].trim()),
		yllcorner = parseFloat(string_array[3].split("yllcorner")[1].trim()),
		cell_size = parseFloat(string_array[4].split("cellsize")[1].trim()),
		geojson_data = {type: "FeatureCollection", features: []};
	for (var i = 6; i <= string_array.length -2; i++) {
		var each_row_coor = string_array[i].split(" "),
			y_coor_weight = (string_array.length -2 - i) * cell_size;
		each_row_coor.forEach(function(element, index){
			if (element != 0) {
				var x_coor_weight = index * cell_size,
					z_index = element.trim(),
					base_coor_x = xllcorner + x_coor_weight,
					base_coor_y = yllcorner + y_coor_weight,
					this_polygon_array = [coor_transformation([base_coor_x, base_coor_y]), coor_transformation([base_coor_x +cell_size , base_coor_y]), coor_transformation([base_coor_x +cell_size, base_coor_y +cell_size]), coor_transformation([base_coor_x, base_coor_y+cell_size])];
				geojson_data.features.push({
	                "type": "Feature",
	                "geometry": {
	                    "type": "Polygon",
	                    "coordinates": [this_polygon_array]
	                },
	                "properties": {
	                    "flow_depth": parseFloat(element)
	                }
				});
			}
		});
	};
	return geojson_data;
}

function downloadxlsx(filename, sheetname, data) {
    //datenum
    function datenum(v, date1904) {
        if (date1904) v += 1462;
        var epoch = Date.parse(v);
        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
    }
    //sheet_from_array_of_arrays
    function sheet_from_array_of_arrays(data, opts) {
        var ws = {};
        var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
        for (var R = 0; R != data.length; ++R) {
            for (var C = 0; C != data[R].length; ++C) {
                if (range.s.r > R) range.s.r = R;
                if (range.s.c > C) range.s.c = C;
                if (range.e.r < R) range.e.r = R;
                if (range.e.c < C) range.e.c = C;
                var cell = { v: data[R][C] };
                if (cell.v == null) continue;
                var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

                if (typeof cell.v === 'number') cell.t = 'n';
                else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                    cell.v = datenum(cell.v);
                }
                else cell.t = 's';

                ws[cell_ref] = cell;
            }
        }
        if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
        return ws;
    }
    //s2ab
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    //Workbook
    function Workbook() {
        if (!(this instanceof Workbook)) return new Workbook();
        this.SheetNames = [];
        this.Sheets = {};
    }
    //write
    var wb = new Workbook();
    data.forEach(function(each_spreadsheet_data, index){
	    var ws = sheet_from_array_of_arrays(each_spreadsheet_data);
	    wb.SheetNames.push(sheetname[index]);
	    wb.Sheets[sheetname[index]] = ws;
    });
    var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    //saveAs
    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), filename)
}

function render_block_chart(input){
    var chart = Highcharts.chart(input.div, {
        title: {
            text: input.title
        },
        chart: {
            zoomType: 'xy'
        },
        xAxis: {
            gridLineWidth: 1,
            title: {
                enabled: true,
                text: input.x_label
            },
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true,
            max: input.x_axis_limit,
            min: 0
        },
        yAxis: {
            title: {
                text: input.y_label
            },
            max: input.y_axis_limit,
            min: 0
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
        },
        series: [{
            name: '安全區域',
            type: 'polygon',
            data: input.green_block,
            color: Highcharts.Color(Highcharts.getOptions().colors[2]).setOpacity(0.5).get(),
            enableMouseTracking: false
        }, {
            name: '警戒區域',
            type: 'polygon',
            data: input.red_block,
            color: Highcharts.Color(Highcharts.getOptions().colors[5]).setOpacity(0.5).get(),
            enableMouseTracking: false
        }, {
            name: 'RTI',
            type: 'line',
            data: input.scatter,
            color: Highcharts.getOptions().colors[1],
        }, {
            name: '目前時間點',
            type: 'scatter',
            data: input.scatter_time,
            color: 'red',
            dataLabels: {
                enabled: true,
                formatter: function(){
					return input.target_time;
                }
            }
        }],
        tooltip: {
            formatter: function(){
				if (this.point.series.name == "RTI") {
					return input.time_label[this.point.index] + '<br>' + this.point.x.toFixed(2) + " " + input.x_label + ',' + this.point.y + ' ' + input.y_label;
				}
				if (this.point.series.name == "目前時間點") {
					return input.target_time + '<br>' + this.point.x.toFixed(2) + " " + input.x_label + ',' + this.point.y + ' ' + input.y_label;
				}
            }
        }
    })
}

function condition_eq_intensity(input){
	var ans
	switch (String(input)) {
	    case '2':
	        ans = "2級";
	        break;
	    case '3':
	        ans = "3級";
			break;
		case '4':
			ans = "4級";
			break;
		case '5':
			ans = "5弱";
			break;
		case '5.5':
			ans = "5強";
			break;
		case '6':
			ans = "6弱";
			break;
		case '6.5':
			ans = "6強";
			break;
		case '7':
			ans = "7級";
			break;
	}
	return ans
}

function condition_disa_level(input){
	var ans;
	switch (input) {
	    case '1':
	        ans = "輕微";
	        break;
	    case '9':
	        ans = "重大敏感";
	        break;
	}
	return ans;
}

function condition_disa_level_component(input){
	var ans;
	switch (input) {
	    case '1':
	        ans = '<span class="badge badge-success align-bottom">輕微</span>';
	        break;
	    case '9':
	        ans = '<span class="badge badge-danger align-bottom">重大敏感</span>';
	        break;
	}
	return ans;
}

function condition_reservior_status(input){
	var result;
	var status = String(parseInt(input));
	switch(status){
		case "0":
			result = '洩洪中';
			break;
		case "1":
			result = '川流式';
			break;
		case "2":
			result = '空庫排砂';
			break;
		case "3":
			result = '自由溢流';
			break;
		case "4":
			result = '調節性放水';
			break;
		case "5":
			result = '預計放流';
			break;
		default:
			result = "無洩洪";
			break;
	};
	return result;
}

function condition_ls_class(input){
	var ans;
	switch (input) {
	    case 'N':
	    	ans = ["community_grey.png", "極低風險"];
	    	break;
	    case 'L':
	        ans = ["community_yellow.png", "低風險"];
	        break;
	   	case 'ML':
	        ans = ["community_orange.png", "中低風險"];
	     	break;
	    case 'M':
	        ans = ["community_depthorange.png", "中風險"];
	        break;
	    case 'MH':
	        ans = ["community_purple.png", "中高風險"];
	        break;
	   	case 'H':
	        ans = ["community_red.png", "高風險"];
	        break;
	}
	return ans;
}

function condition_area(input){
	var ans;
	switch (input) {
	    case '001':
	        ans = "石門區";
	        break;
	    case '002':
	        ans = "三芝區";
	        break;
	   	case '003':
	        ans = "金山區";
	     	break;
	    case '004':
	        ans = "淡水區";
	        break;
	    case '005':
	        ans = "萬里區";
	        break;
	   	case '009':
	        ans = "八里區";
	        break;
	    case '014':
	        ans = "汐止區";
	        break;
	    case '016':
	        ans = "林口區";
	        break;
	   	case '017':
	        ans = "五股區";
	     	break;
	    case '018':
	        ans = "瑞芳區";
	        break;
	    case '023':
	        ans = "蘆洲區";
	        break;
	   	case '024':
	        ans = "雙溪區";
	        break;
	   	case '025':
	        ans = "三重區";
	        break;
	    case '027':
	        ans = "貢寮區";
	        break;
	   	case '029':
	        ans = "平溪區";
	     	break;
	    case '033':
	        ans = "新莊區";
	        break;
	    case '040':
	        ans = "石碇區";
	        break;
	   	case '041':
	        ans = "板橋區";
	        break;
	   	case '044':
	        ans = "深坑區";
	        break;
	    case '045':
	        ans = "永和區";
	        break;
	   	case '046':
	        ans = "樹林區";
	     	break;
	    case '048':
	        ans = "中和區";
	        break;
	    case '049':
	        ans = "土城區";
	        break;
	   	case '050':
	        ans = "新店區";
	        break;
	   	case '053':
	        ans = "坪林區";
	        break;
	   	case '054':
	        ans = "鶯歌區";
	        break;
	   	case '057':
	        ans = "三峽區";
	        break;
	   	case '061':
	        ans = "烏來區";
	        break;
	   	case '062':
	        ans = "泰山區";
	        break;
		default:
			ans = "無資料"
	}
	return ans;
}

function condition_disa_type(input){
	var ans;
	switch (parseInt(input)) {
	    case 1:
	        ans = "積水";
	        break;
	    case 10:
	        ans = "圍籬及鐵皮倒塌";
	        break;
	   	case 102:
	        ans = "招牌掉落";
	     	break;
	    case 103:
	        ans = "溺水";
	        break;
	    case 11:
	        ans = "路樹傾倒";
	        break;
	   	case 12:
	        ans = "電線掉落";
	        break;
	    case 13:
	        ans = "電線桿傾倒";
	        break;
	    case 14:
	        ans = "交通號誌損壞";
	        break;
	   	case 17:
	        ans = "道路封閉";
	     	break;
	    case 18:
	        ans = "鐵路損壞";
	        break;
	    case 19:
	        ans = "橋樑損壞";
	        break;
	   	case 2:
	        ans = "淹水";
	        break;
	   	case 20:
	        ans = "重大交通事故";
	        break;
	    case 21:
	        ans = "山難";
	        break;
	   	case 22:
	        ans = "海難";
	     	break;
	    case 23:
	        ans = "空難";
	        break;
	    case 24:
	        ans = "電力停電";
	        break;
	   	case 25:
	        ans = "瓦斯漏氣";
	        break;
	   	case 26:
	        ans = "自來水管線破裂";
	        break;
	    case 27:
	        ans = "電話停話";
	        break;
	   	case 28:
	        ans = "地層滑動";
	     	break;
	    case 30:
	        ans = "山洪爆發";
	        break;
	    case 32:
	        ans = "溪水暴漲";
	        break;
	   	case 33:
	        ans = "海水倒灌";
	        break;
	   	case 34:
	        ans = "堤防潰決";
	        break;
	    case 35:
	        ans = "其他";
	        break;
	    case 37:
	        ans = "坡地社區災害";
	        break;
	   	case 38:
	        ans = "人員受困";
	        break;
	   	case 39:
	        ans = "房屋淹水";
	        break;
	   	case 4:
	        ans = "土石流";
	        break;
	    case 40:
	        ans = "人員疏散及災民收容";
	        break;
	    case 5:
	        ans = "道路受損";
	        break;
	   	case 51:
	        ans = "汙泥未清";
	        break;
	   	case 6:
	        ans = "道路坍方落石";
	        break;
	   	case 60:
	        ans = "捷運工程災害";
	        break;
	   	case 61:
	        ans = "捷運營運災害";
	        break;
	   	case 62:
	        ans = "停水";
	        break;
	    case 7:
	        ans = "房屋半倒(毀損)";
	        break;
	    case 8:
	        ans = "房屋全倒";
	        break;
	   	case 999:
	        ans = "測試案類";
	        break;
	   	default:
	        ans = "其它";
	}
	return ans;
}

function condition_status_type(input){
	var ans;
	switch (input) {
	    case '00':
	        ans = "待分派";
	        break;
	    case '01':
	    case '02':
	        ans = "未結案";
	        // ans = "待分派";
	        break;
	   	case '04':
	        ans = "未結案";
	        // ans = "待分派";
	     	break;
	    case '05':
	        ans = "已結案";
	        break;
	    case '10':
	        ans = "已取消";
	        break;
	   	case '11':
	        ans = "已併案";
	        break;
	}
	return ans;
}

function condition_block_traffic(input){
	if (input > 0) return '是'
	else return '否'
}

function condition_DM0302_status(input){
	var ans;
	switch (parseInt(input)) {
	    case 0:
	        ans = "待回覆";
	        break;
	    case 1:
	        ans = "取消";
	        break;
	   	case 2:
	        ans = "覆核確認";
	     	break;
	    case 3:
	        ans = "非權責";
	        break;
	    case 4:
	        ans = "已回覆";
	        break;
	   	case 5:
	        ans = "已結案";
	        break;
	   	default:
	        ans = "其它";
	}
	return ans;
}

function condition_DM0302_status_color(input){
	var ans;
	switch (parseInt(input)) {
	    case 0:
	        ans = ["red", "danger"];
	        break;
	    case 1:
	        ans = ["green", "success"];
	        break;
	   	case 2:
	        ans = ["red", "danger"];
	     	break;
	    case 3:
	        ans = ["green", "success"];
	        break;
	    case 4:
	        ans = ["orange", "warning"];
	        break;
	   	case 5:
	        ans = ["green", "success"];
	        break;
	   	default:
	        ans = ["green", "success"];
	}
	return ans;
}

function condition_who(input, input2){
	var result = null;
	var lists = {
		"2":"秘書處",
		"20100":"市長辦公室",
		"20200":"李副市長辦公室",
		"20300":"許副市長辦公室",
		"20400":"侯副市長辦公室",
		"20500":"秘書長辦公室",
		"20600":"宋副秘書長辦公室",
		"20700":"許副秘書長辦公室",
		"20800":"府本部參議辦公室",
		"20900":"府本部顧問辦公室",
		"21000":"府本部參事、秘書辦公室",
		"21100":"府本部技監辦公室",
		"21200":"處長辦公室",
		"21300":"副處長辦公室",
		"21400":"主任秘書辦公室",
		"21500":"處本部",
		"21600":"文書科",
		"21700":"檔案科",
		"21800":"事務科",
		"21900":"機要科",
		"22000":"國際事務科",
		"22100":"行政園區管理科",
		"22200":"人事室",
		"22300":"會計室",
		"22400":"政風室",
		"29900":"其他",
		"101":"民政局",
		"1010000":"臺北縣政府民政局",
		"1010100":"局本部",
		"1010200":"地方行政科",
		"1010300":"宗教禮俗科",
		"1010400":"戶政科",
		"1010500":"生命禮儀科",
		"1010600":"兵役徵集科",
		"1010700":"兵役勤管科",
		"1010800":"秘書室",
		"1010900":"人事室",
		"1011000":"會計室",
		"1011100":"政風室",
		"1011200":"地方自治科",
		"102":"財政局",
		"1020100":"局本部",
		"1020200":"財稅管理科",
		"1020300":"庫款支付科",
		"1020400":"菸酒金融科",
		"1020600":"秘書室",
		"1020700":"人事室",
		"1020800":"會計室",
		"1020900":"政風室",
		"1021000":"財產開發科",
		"1021100":"非公用財產管理科",
		"1021200":"公用財產管理科",
		"103":"經濟發展局",
		"1030100":"局本部",
		"1030200":"工業輔導科",
		"1030300":"工商登記科",
		"1030400":"公用事業科",
		"1030500":"商業輔導科",
		"1030600":"招商科",
		"1030700":"工商企劃科",
		"1030800":"秘書室",
		"1030900":"人事室",
		"1031000":"會計室",
		"1031100":"政風室",
		"1031300":"綠色產業發展中心",
		"104":"觀光旅遊局",
		"1040100":"局本部",
		"1040200":"觀光技術科",
		"1040300":"旅遊行銷科",
		"1040400":"觀光企劃科",
		"1040500":"觀光管理科",
		"1040600":"風景區管理科",
		"1040700":"秘書室",
		"1040800":"人事室",
		"1040900":"會計室",
		"1041000":"政風室",
		"105":"教育局",
		"1050100":"局本部",
		"1050200":"督學室",
		"1050300":"國小教育科",
		"1050400":"永續環境教育科",
		"1050500":"社會教育科",
		"1050600":"學生事務科",
		"1050700":"中等教育科",
		"1050800":"特殊教育科",
		"1050900":"幼兒教育科",
		"1051000":"教育研究發展科",
		"1051100":"秘書室",
		"1051200":"人事室",
		"1051300":"會計室",
		"1051400":"政風室",
		"1051500":"新住民文教輔導科",
		"1051700":"軍訓室",
		"106":"工務局",
		"1060100":"局本部",
		"1060200":"工務科",
		"1060300":"養護工程處",
		"1060400":"建照科",
		"1060500":"施工科",
		"1060600":"公寓大廈管理科",
		"1060700":"使用管理科",
		"1060800":"違章建築拆除大隊",
		"1060900":"工程科",
		"1061100":"規劃設計科",
		"1061400":"秘書室",
		"1061500":"人事室",
		"1061600":"會計室",
		"1061700":"政風室",
		"1061800":"採購處",
		"107":"水利局",
		"1070100":"局本部",
		"1070200":"水利行政科",
		"1070300":"河川工程科",
		"1070400":"雨水下水道工程科",
		"1070500":"污水下水道工程科",
		"1070600":"抽水站管理科",
		"1070700":"污水設施科",
		"1070800":"水利工程養護科",
		"1070900":"秘書室",
		"1071000":"人事室",
		"1071100":"會計室",
		"1071200":"政風室",
		"1071300":"污水下水道計畫科",
		"1071400":"河川計畫科",
		"1079900":"其他",
		"108":"農業局",
		"1080100":"局本部",
		"1080200":"農牧經營管理科",
		"1080300":"林務科",
		"1080400":"漁業及漁港事業管理處",
		"1080500":"農漁會輔導科",
		"1080600":"山坡地保育科",
		"1080700":"農業工程科",
		"1080800":"秘書室",
		"1080900":"人事室",
		"1081000":"會計室",
		"1081100":"政風室",
		"109":"城鄉發展局",
		"1090100":"局本部",
		"1090200":"城鄉規劃科",
		"1090400":"都計測量科",
		"1090500":"城鄉開發科",
		"1090600":"企劃建築科",
		"1090700":"都市設計科",
		"1090800":"秘書室",
		"1090900":"人事室",
		"1091000":"會計室",
		"1091100":"政風室",
		"1091300":"計畫審議科",
		"1091400":"綜合規劃科",
		"1091600":"都市計畫科",
		"1091700":"開發管理科",
		"1091800":"都市更新處",
		"110":"社會局",
		"1100100":"局本部",
		"1100200":"人民團體科",
		"1100300":"社區發展及婦女福利科",
		"1100400":"社會救助科",
		"1100500":"兒童少年福利科",
		"1100600":"身心障礙福利科",
		"1100700":"老人福利科",
		"1100800":"社會工作科",
		"1100900":"秘書室",
		"1101000":"人事室",
		"1101100":"會計室",
		"1101200":"政風室",
		"1101300":"文山中心",
		"1101400":"新泰中心",
		"1101500":"雙和中心",
		"1101600":"板橋中心",
		"1101700":"三重中心",
		"1101800":"土城中心",
		"1101900":"北海岸中心",
		"1102000":"七星中心",
		"1102100":"蘆洲中心",
		"1102200":"三鶯中心",
		"1102500":"高風險家庭服務管理中心",
		"111":"地政局",
		"1110100":"局本部",
		"1110200":"地籍科",
		"1110300":"地政資料科",
		"1110400":"地價科",
		"1110500":"徵收科",
		"1110600":"編定管制科",
		"1110700":"重劃科",
		"1110800":"區段徵收科",
		"1110900":"地籍測量科",
		"1111000":"秘書室",
		"1111100":"人事室",
		"1111200":"會計室",
		"1111300":"政風室",
		"111900":"地籍測量科",
		"1119900":"其他",
		"112":"勞工局",
		"1120100":"勞工育樂科",
		"1120200":"勞安條件科",
		"1120300":"勞資關係科",
		"1120400":"勞工組織科",
		"1120500":"身障就業輔導科",
		"1120600":"外勞服務科",
		"1120700":"秘書室",
		"1120800":"人事室",
		"1120900":"會計室",
		"1121000":"政風室",
		"1121200":"局本部",
		"1121300":"就業服務中心",
		"113":"交通局",
		"1130100":"局本部",
		"1130200":"運輸規劃科",
		"1130201":"運輸規劃科第一股",
		"1130202":"運輸規劃科第二股",
		"1130300":"運輸管理科",
		"1130301":"運輸管理科第一股",
		"1130302":"運輸管理科第二股",
		"1130400":"交通管制工程科",
		"1130401":"交通管制工程科第一股",
		"1130402":"交通管制工程科第二股",
		"1130403":"交通管制工程科第三股",
		"1130500":"停車管理科",
		"1130501":"停車管理科第一股",
		"1130502":"停車管理科第二股",
		"1130503":"捷運處",
		"1130600":"停車營運科",
		"1130601":"停車營運科第一股",
		"1130602":"停車營運科第二股",
		"1130603":"停車營運科第三股",
		"1130605":"停營科板橋場",
		"1130606":"停營科新莊場",
		"1130607":"停營科三重場",
		"1130608":"停營科中和場",
		"1130609":"停營科永和場",
		"1130610":"停營科新店場",
		"1130611":"停營科土城場",
		"1130700":"交通安全科",
		"1130701":"交通安全科第一股",
		"1130702":"交通安全科第二股",
		"1130800":"軌道工程科",
		"1130801":"軌道工程科第一股",
		"1130802":"軌道工程科第二股",
		"1130900":"秘書室",
		"1131000":"人事室",
		"1131100":"會計室",
		"1131200":"政風室",
		"113602":"停車營運科第二股",
		"114":"新聞局",
		"1140100":"局本部",
		"1140200":"綜合行銷科",
		"1140300":"新聞聯繫科",
		"1140400":"新聞行政科",
		"1140500":"秘書室",
		"1140600":"人事管理員",
		"1140700":"會計員",
		"115":"法制局",
		"1150100":"局本部",
		"1150200":"法規審議科",
		"1150400":"消費者保護官室",
		"1150500":"採購申訴審議科",
		"1150600":"秘書室",
		"1150700":"人事管理員",
		"1150800":"會計員",
		"1150900":"行政救濟一科",
		"1151000":"行政救濟二科",
		"116":"研究發展考核委員會",
		"1160000":"新北市政府研究發展考核委員會",
		"1160100":"會本部",
		"1160200":"綜合規劃組",
		"1160300":"計畫管制組",
		"1160400":"研究發展組",
		"1160500":"為民服務組",
		"1160600":"施政考核組",
		"1160700":"秘書室",
		"1160800":"人事室",
		"1160900":"會計室",
		"1161000":"政風室",
		"1169900":"1999話務中心",
		"117":"原住民族行政局",
		"1170000":"新北市政府原住民族行政局",
		"1170100":"局本部",
		"1170200":"教育文化科",
		"1170300":"社會福利科",
		"1170400":"經濟建設科",
		"1170500":"秘書室",
		"118":"主計處",
		"1180100":"處本部",
		"1180200":"第一科",
		"1180300":"第二科",
		"1180400":"第五科",
		"1180500":"第三科",
		"1180600":"第四科",
		"1180700":"秘書室",
		"1180800":"人事室",
		"1180900":"政風室",
		"1181000":"會計室",
		"119":"人事處",
		"1190100":"處本部",
		"1190200":"企劃科",
		"1190300":"人力科",
		"1190400":"考訓科",
		"1190500":"給與科",
		"1190600":"秘書室",
		"1190700":"人事管理員",
		"1190800":"會計員",
		"120":"政風處",
		"1200100":"處本部",
		"1200200":"第一科",
		"1200300":"第二科",
		"1200400":"第三科",
		"1200600":"人事管理員",
		"1200700":"會計員",
		"1200800":"第四科",
		"121":"客家事務局",
		"1210100":"局本部",
		"1210200":"綜合規劃科",
		"1210300":"文教發展科",
		"1210400":"園區管理科",
		"1210500":"秘書室",
		"1210600":"人事室",
		"1210700":"會計室",
		"122":"環境保護局",
		"1220200":"局長室",
		"1220300":"副局長室",
		"1220400":"主任秘書室",
		"1220500":"人事室",
		"1220600":"會計室",
		"1220700":"政風室",
		"1220800":"綜合規劃科",
		"1220801":"評估規劃股",
		"1220802":"教育宣導股",
		"1220900":"空氣品質維護科",
		"1220901":"固定源管制股",
		"1220902":"移污噪音股",
		"1221000":"水質保護科",
		"1221001":"水污染防治股",
		"1221002":"水質管理股",
		"1221100":"環境衛生管理科",
		"1221101":"資源回收股",
		"1221102":"環境衛生管理股",
		"1221103":"環境維護股",
		"1221200":"環境檢驗科",
		"1221201":"技術規劃股",
		"1221202":"檢測股",
		"1221300":"事業廢棄物管理科",
		"1221301":"許可管理股",
		"1221302":"運作管制股",
		"1221400":"廢棄物處理規劃科",
		"1221401":"興建規劃股",
		"1221402":"營運管理股",
		"1221500":"環保稽查科",
		"1221501":"環保稽查科第一股",
		"1221502":"環保稽查科第二股",
		"1221600":"秘書室",
		"1221601":"事務股",
		"1221602":"採購股",
		"1221603":"研考法制股",
		"1221700":"八里垃圾掩埋場",
		"1221800":"八里垃圾焚化廠",
		"1221900":"樹林垃圾焚化廠",
		"1222000":"新店垃圾焚化廠",
		"1222200":"低碳社區發展中心",
		"1222201":"低碳策略規劃股",
		"1222202":"社區推廣發展股",
		"1223800":"中和區清潔隊",
		"123":"文化局",
		"1230100":"局本部",
		"1230200":"文化發展科",
		"1230201":"文化產業股",
		"1230202":"綜合企劃股",
		"1230300":"藝術展演科",
		"1230301":"視覺藝術股",
		"1230302":"表演藝術股",
		"1230400":"藝文推廣科",
		"1230401":"社區文化股",
		"1230402":"藝文活動股",
		"1230500":"文化資產科",
		"1230501":"有形資產股",
		"1230502":"無形資產股",
		"1230503":"園區管理股",
		"1230600":"秘書室",
		"1230700":"人事室",
		"1230800":"會計室",
		"1230900":"政風室",
		"1231000":"文化設施科",
		"1231001":"設施營運股",
		"1231002":"設計規劃股",
		"124":"衛生局",
		"1240100":"局本部",
		"1240200":"健康管理科",
		"1240300":"疾病管制科",
		"1240400":"醫事管理科",
		"1240500":"食品藥物管理科",
		"1240600":"衛生企劃科",
		"1240700":"衛生稽查科",
		"1240800":"檢驗科",
		"1240900":"心理衛生及長期照顧科",
		"1241000":"秘書室",
		"1241100":"人事室",
		"1241200":"會計室",
		"1241300":"政風室",
		"1241400":"長期照顧中心",
		"125":"警察局",
		"1250100":"局長室",
		"1250101":"局本部",
		"1250200":"副局長室(一)",
		"1250300":"副局長室(二)",
		"1250400":"副局長室(三)",
		"1250500":"主任秘書室",
		"1250700":"刑事鑑識中心",
		"1250800":"督察室",
		"1250900":"外事科",
		"1251000":"後勤科",
		"1251100":"行政科",
		"1251200":"資訊室",
		"1251300":"訓練科",
		"1251400":"犯罪預防科",
		"1251500":"公共關係室",
		"1251600":"防治科",
		"1251700":"會計室",
		"1251800":"保安民防科",
		"1251900":"民防管制中心",
		"1252000":"勤務指揮中心",
		"1252100":"保防室",
		"1252300":"秘書室",
		"1252400":"人事室",
		"1252500":"法制室",
		"1252600":"政風室",
		"1252700":"統計室",
		"1253000":"交通警察大隊",
		"1253100":"少年警察隊",
		"1253200":"婦幼警察隊",
		"1253300":"板橋分局",
		"1253400":"海山分局",
		"1253500":"三重分局",
		"1253600":"新莊分局",
		"1253700":"中和分局",
		"1253800":"永和分局",
		"1253900":"新店分局",
		"1254000":"土城分局",
		"1254100":"蘆洲分局",
		"1254200":"汐止分局",
		"1254300":"樹林分局",
		"1254400":"淡水分局",
		"1254500":"三峽分局",
		"1254600":"瑞芳分局",
		"1254700":"金山分局",
		"1254800":"林口分局",
		"1254900":"刑事警察大隊",
		"1255000":"保安警察大隊",
		"126":"消防局",
		"1260100":"局本部",
		"1260101":"局長室",
		"1260102":"副局長室",
		"1260103":"主任秘書室",
		"1260104":"1999話務中心",
		"1260200":"火災調查科",
		"1260300":"災害管理科",
		"1260400":"車輛保養中心",
		"1260500":"督察室",
		"1260600":"救災救護指揮中心",
		"1260700":"教育訓練科",
		"1260800":"緊急救護科",
		"1260900":"災害搶救科",
		"1261000":"火災預防科",
		"1261100":"危險物品管理科",
		"1261200":"民力運用科",
		"1261300":"1999話務中心",
		"1261400":"秘書室",
		"1261500":"人事室",
		"1261600":"會計室",
		"1261700":"政風室",
		"1261801":"第一救災救護大隊隊本部",
		"1261802":"第七救災救護大隊中和分隊",
		"1261803":"第七救災救護大隊永和分隊",
		"1261804":"第七救災救護大隊永利分隊",
		"1261805":"第七救災救護大隊南勢分隊",
		"1261806":"第七救災救護大隊員山分隊",
		"1261807":"第一救災救護大隊莒光分隊",
		"1261808":"第一救災救護大隊板橋分隊",
		"1261809":"第一救災救護大隊大觀分隊",
		"1261810":"第一救災救護大隊海山分隊",
		"1261811":"第一救災救護大隊民生分隊",
		"1261812":"第七救災救護大隊國光分隊",
		"1261813":"第一救災救護大隊溪崑分隊",
		"1261814":"第一救災救護大隊海山中隊",
		"1261815":"第一救災救護大隊中和中隊",
		"1261816":"第一救災救護大隊永平分隊",
		"1261817":"第一救災救護大隊新板分隊",
		"1261901":"第二救災救護大隊隊本部",
		"1261902":"第二救災救護大隊新莊分隊",
		"1261903":"第二救災救護大隊福營分隊",
		"1261904":"第二救災救護大隊中港分隊",
		"1261905":"第二救災救護大隊泰山分隊",
		"1261906":"第二救災救護大隊林口分隊",
		"1261907":"第二救災救護大隊五工分隊",
		"1261908":"第二救災救護大隊五股分隊",
		"1261909":"第二救災救護大隊德音分隊",
		"1261910":"第二救災救護大隊頭前分隊",
		"1261911":"第二救災救護大隊更寮分隊",
		"1261912":"第二救災救護大隊五泰林中隊",
		"1261913":"第二救災救護大隊新莊中隊",
		"1261914":"第二救災救護大隊裕民分隊",
		"1262001":"第三救災救護大隊隊本部",
		"1262002":"第三救災救護大隊三重分隊",
		"1262003":"第三救災救護大隊重陽分隊",
		"1262004":"第三救災救護大隊慈福分隊",
		"1262005":"第三救災救護大隊二重分隊",
		"1262006":"第三救災救護大隊鷺江分隊",
		"1262007":"第三救災救護大隊蘆洲分隊",
		"1262008":"第三救災救護大隊龍源分隊",
		"1262009":"第三救災救護大隊八里分隊",
		"1262010":"第三救災救護大隊淡水分隊",
		"1262011":"第三救災救護大隊竹圍分隊",
		"1262012":"第三救災救護大隊三芝分隊",
		"1262013":"第三救災救護大隊淡水中隊",
		"1262014":"第三救災救護大隊三重中隊",
		"1262101":"第四救災救護大隊隊本部",
		"1262102":"第四救災救護大隊新店分隊",
		"1262103":"第四救災救護大隊直潭分隊",
		"1262104":"第四救災救護大隊安康分隊",
		"1262105":"第四救災救護大隊深坑分隊",
		"1262106":"第四救災救護大隊石碇分隊",
		"1262107":"第四救災救護大隊坪林分隊",
		"1262108":"第四救災救護大隊烏來分隊",
		"1262109":"第四救災救護大隊雪山分隊",
		"1262111":"第四救災救護大隊安和分隊",
		"1262112":"第四救災救護大隊新店中隊",
		"1262201":"第五救災救護大隊隊本部",
		"1262202":"第五救災救護大隊土城分隊",
		"1262203":"第五救災救護大隊清水分隊",
		"1262204":"第五救災救護大隊頂埔分隊",
		"1262205":"第五救災救護大隊樹林分隊",
		"1262206":"第五救災救護大隊樹潭分隊",
		"1262207":"第五救災救護大隊柑園分隊",
		"1262208":"第五救災救護大隊隆恩分隊",
		"1262209":"第五救災救護大隊三峽分隊",
		"1262210":"第五救災救護大隊鶯歌分隊",
		"1262211":"第五救災救護大隊樹林中隊",
		"1262212":"第五救災救護大隊土城中隊",
		"1262301":"第六救災救護大隊隊本部",
		"1262302":"第六救災救護大隊秀峰分隊",
		"1262303":"第六救災救護大隊社后分隊",
		"1262304":"第六救災救護大隊汐止分隊",
		"1262305":"第六救災救護大隊橫科分隊",
		"1262306":"第六救災救護大隊長青分隊",
		"1262307":"第六救災救護大隊瑞芳分隊",
		"1262308":"第六救災救護大隊瑞亭分隊",
		"1262309":"第六救災救護大隊金山分隊",
		"1262310":"第六救災救護大隊石門分隊",
		"1262311":"第六救災救護大隊萬里分隊",
		"1262312":"第六救災救護大隊雙溪分隊",
		"1262313":"第六救災救護大隊貢寮分隊",
		"1262314":"第六救災救護大隊平溪分隊",
		"1262315":"第六救災救護大隊九份分隊",
		"1262316":"第六救災救護大隊瑞芳中隊",
		"1262317":"第六救災救護大隊保長分隊",
		"1262318":"第七救災救護大隊隊本部",
		"1262700":"減災規劃科",
		"1262800":"整備應變科",
		"1262900":"資通管考科",
		"127":"捷運工程局",
		"1270100":"局本部",
		"1270200":"綜合規劃科",
		"1270300":"工程管理科",
		"1270400":"土木建築科",
		"1270500":"土地開發科",
		"1270600":"祕書室",
		"1270700":"人事室",
		"1270800":"政風室",
		"1270900":"會計室",
		"1271000":"機電系統科",
		"1271100":"資財管理科",
		"1271200":"技術發展科",
		"1271300":"淡海工務所",
		"1271400":"安坑工務所",
		"156":"",
		"180":"",
		"2020304":"資訊科第三股",
		"2120100":"中心本部",
		"2120200":"系統發展科",
		"2120300":"資通管理科",
		"2120500":"網際服務科",
		"2120600":"數位推廣科",
		"2171100":"永和分館",
		"2171500":"土城分館",
		"2172200":"汐止分館",
		"2172400":"泰山分館",
		"2220000":"綠美化環境景觀處",
		"301":"板橋區公所",
		"3010000":"板橋區公所",
		"3010100":"所本部",
		"3010200":"社會課",
		"3010300":"役政災防課",
		"3010400":"民政課",
		"3010500":"秘書室",
		"3010600":"人事室",
		"3010700":"工務課",
		"3011000":"經建課",
		"3011200":"會計室",
		"3011300":"養護工程課",
		"3011400":"政風室",
		"3011800":"人文課",
		"302":"三重區公所",
		"3020000":"三重區公所",
		"3020100":"所本部",
		"3020200":"役政災防課",
		"3020400":"民政課",
		"3020500":"人事室",
		"3020600":"秘書室",
		"3021000":"社會人文課",
		"3021300":"經建課",
		"3021400":"工務課",
		"3021500":"會計室",
		"3021600":"政風室",
		"303":"永和區公所",
		"3030100":"所本部",
		"3030200":"民政課",
		"3030400":"會計室",
		"3030500":"社會人文課",
		"3030600":"經建課",
		"3030700":"工務課",
		"3031000":"清潔隊",
		"3031100":"秘書室",
		"3031200":"人事室",
		"3031400":"政風室",
		"3031700":"役政災防課",
		"304":"中和區公所",
		"3040100":"所本部",
		"3040200":"民政課",
		"3040300":"人事室",
		"3040400":"秘書室",
		"3040500":"工務課",
		"3040800":"經建課",
		"3040900":"役政災防課",
		"3041000":"社會課",
		"3041100":"人文課",
		"3041400":"政風室",
		"3041500":"會計室",
		"305":"新莊區公所",
		"3050100":"所本部",
		"3050200":"秘書室",
		"3050300":"社會課",
		"3050400":"經建課",
		"3050600":"工務課",
		"3050800":"民政課",
		"3051000":"役政災防課",
		"3051100":"政風室",
		"3051200":"人事室",
		"3051400":"會計室",
		"3051800":"人文課",
		"306":"新店區公所",
		"3060100":"所本部",
		"3060200":"役政災防課",
		"3060300":"民政課",
		"3060400":"工務課",
		"3060600":"人事室",
		"3060700":"秘書室",
		"3060800":"會計室",
		"3061300":"經建課",
		"3061400":"社會人文課",
		"3061600":"政風室",
		"307":"土城區公所",
		"3070000":"土城區公所",
		"3070100":"所本部",
		"3070200":"經建課",
		"3070400":"役政災防課",
		"3070500":"秘書室",
		"3070600":"民政課",
		"3070700":"人事室",
		"3070800":"社會人文課",
		"3070900":"工務課",
		"3071000":"會計室",
		"3071100":"政風室",
		"308":"蘆洲區公所",
		"3080100":"所本部",
		"3080200":"民政課",
		"3080400":"經建課",
		"3080500":"工務課",
		"3080600":"役政災防課",
		"3080700":"社會人文課",
		"3080800":"人事室",
		"3080900":"會計室",
		"3081000":"政風室",
		"3081300":"秘書室",
		"309":"樹林區公所",
		"3090000":"樹林區公所",
		"3090100":"所本部",
		"3090200":"人事室",
		"3090300":"工務課",
		"3090400":"經建課",
		"3090500":"秘書室",
		"3090800":"民政課",
		"3090900":"社會人文課",
		"3091000":"役政災防課",
		"3091100":"會計室",
		"3091200":"政風室",
		"310":"鶯歌區公所",
		"3100000":"鶯歌區公所",
		"3100100":"所本部",
		"3100200":"秘書室",
		"3100300":"社會人文課",
		"3100400":"民政災防課",
		"3100700":"會計室",
		"3100800":"政風室",
		"3100900":"工務課",
		"3101200":"人事室",
		"3101500":"經建課",
		"311":"三峽區公所",
		"3110100":"所本部",
		"3110200":"人事室",
		"3110300":"工務課",
		"3110400":"秘書室",
		"3110500":"民政課",
		"3110700":"會計室",
		"3110800":"經建課",
		"3110900":"社會人文課",
		"3111000":"政風室",
		"3111400":"役政災防課",
		"312":"淡水區公所",
		"3120100":"所本部",
		"3120200":"經建課",
		"3120400":"秘書室",
		"3120500":"人事室",
		"3120600":"民政課",
		"3120700":"政風室",
		"3121100":"會計室",
		"3121500":"工務課",
		"3121600":"社會人文課",
		"3121700":"役政災防課",
		"313":"瑞芳區公所",
		"3130100":"所本部",
		"3130200":"民政災防課",
		"3130300":"人事室",
		"3130400":"經建課",
		"3130500":"秘書室",
		"3130700":"會計室",
		"3131200":"政風室",
		"3131300":"社會人文課",
		"3131400":"工務課",
		"314":"汐止區公所",
		"3140100":"所本部",
		"3140200":"政風室",
		"3140300":"人事室",
		"3140400":"會計室",
		"3140600":"秘書室",
		"3140700":"社會人文課",
		"3140800":"役政災防課",
		"3140900":"民政課",
		"3141000":"經建課",
		"3141100":"工務課",
		"315":"五股區公所",
		"3150000":"五股區公所",
		"3150100":"所本部",
		"3150200":"民政災防課",
		"3150400":"工務課",
		"3150500":"經建課",
		"3150600":"社會人文課",
		"3150700":"秘書室",
		"3150800":"人事室",
		"3150900":"會計室",
		"3151300":"政風室",
		"316":"泰山區公所",
		"3160100":"所本部",
		"3160200":"人事室",
		"3160300":"經建課",
		"3160400":"秘書室",
		"3160600":"民政災防課",
		"3160700":"社會人文課",
		"3160800":"工務課",
		"3160900":"會計室",
		"3161000":"政風室",
		"317":"林口區公所",
		"3170000":"林口區公所",
		"3170100":"所本部",
		"3170200":"民政災防課",
		"3170400":"經建課",
		"3170700":"秘書室",
		"3170800":"會計室",
		"3170900":"人事室",
		"3171000":"政風室",
		"3171100":"托兒所",
		"3171200":"工務課",
		"3171300":"社會人文課",
		"318":"八里區公所",
		"3180100":"所本部",
		"3180200":"秘書室",
		"3180300":"民政災防課",
		"3180500":"經建課",
		"3180600":"會計室",
		"3180700":"人事室",
		"3181000":"工務課",
		"3181100":"社會人文課",
		"319":"深坑區公所",
		"3190000":"深坑區公所",
		"3190100":"所本部",
		"3190200":"秘書室",
		"3190300":"民政災防課",
		"3190301":"深坑里辦公處",
		"3190302":"埔新里辦公處",
		"3190303":"萬順里辦公處",
		"3190304":"萬福里辦公處",
		"3190305":"土庫里辦公處",
		"3190306":"賴仲里辦公處",
		"3190307":"昇高里辦公處",
		"3190308":"阿柔里辦公處",
		"3190500":"經建課",
		"3190600":"社會人文課",
		"3190700":"會計室",
		"3190800":"人事管理員",
		"3191200":"工務課",
		"320":"石碇區公所",
		"3200100":"所本部",
		"3200200":"民政災防課",
		"3200500":"經建課",
		"3200800":"秘書室",
		"3200900":"人事管理員",
		"3201000":"會計室",
		"3201200":"社會人文課",
		"3201300":"工務課",
		"321":"坪林區公所",
		"3210000":"坪林區公所",
		"3210200":"秘書室",
		"3210300":"會計室",
		"3210400":"人事管理員",
		"3210600":"工務課",
		"3210700":"經建課",
		"3210800":"社會人文課",
		"3210900":"民政災防課",
		"322":"三芝區公所",
		"3220100":"所本部",
		"3220200":"秘書室",
		"3220300":"民政災防課",
		"3220400":"農經課",
		"3221000":"工務課",
		"3221100":"人事管理員",
		"3221200":"會計室",
		"3221300":"社會人文課",
		"323":"石門區公所",
		"3230100":"所本部",
		"3230200":"民政災防課",
		"3230300":"經建課",
		"3230400":"會計室",
		"3230700":"秘書室",
		"3231100":"人事管理員",
		"3231200":"社會人文課",
		"3231300":"工務課",
		"324":"金山區公所",
		"3240100":"所本部",
		"3240200":"民政災防課",
		"3240300":"社會人文課",
		"3240400":"農經課",
		"3240800":"秘書室",
		"3240900":"人事管理員",
		"3241000":"會計室",
		"3241600":"工務課",
		"325":"萬里區公所",
		"3250100":"所本部",
		"3250200":"民政災防課",
		"3250300":"經建課",
		"3250400":"會計室",
		"3250700":"秘書室",
		"3250800":"財政課",
		"3251200":"人事管理員",
		"3251400":"工務課",
		"3251500":"社會人文課",
		"326":"平溪區公所",
		"3260000":"平溪區公所",
		"3260200":"人事管理員",
		"3260300":"經建課",
		"3260400":"民政災防課",
		"3260600":"會計室",
		"3260900":"秘書室",
		"3261100":"社會人文課",
		"3261200":"工務課",
		"327":"雙溪區公所",
		"3270100":"所本部",
		"3270200":"民政災防課",
		"3270300":"農經課",
		"3270400":"社會人文課",
		"3270500":"秘書室",
		"3270800":"會計室",
		"3270900":"人事室",
		"3271100":"工務課",
		"328":"貢寮區公所",
		"3280100":"所本部",
		"3280200":"人事管理員",
		"3280300":"工務課",
		"3280400":"民政災防課",
		"3280500":"農經課",
		"3280800":"會計室",
		"3280900":"秘書室",
		"3281200":"社會人文課",
		"329":"烏來區公所",
		"3290000":"烏來區公所",
		"3290100":"所本部",
		"3290200":"民政災防課",
		"3290300":"人事管理員",
		"3290900":"會計室",
		"3291100":"秘書室",
		"3291200":"社會人文課",
		"3291300":"原住民族事務課",
		"3291400":"工務課",
		"3510100":"所本部",
		"3510200":"第一課",
		"3510300":"第二課",
		"3510400":"第三課",
		"3510500":"第四課",
		"3510600":"第五課",
		"3520100":"所本部",
		"3520200":"第一課",
		"3520300":"第二課",
		"3520400":"第三課",
		"3520500":"第四課",
		"3520600":"第五課",
		"3530100":"所本部",
		"3530200":"第一課",
		"3530300":"第二課",
		"3530400":"第三課",
		"3530500":"第四課",
		"3530600":"第五課",
		"3540100":"所本部",
		"3540200":"一課",
		"3540300":"二課",
		"3540400":"三課",
		"3540500":"四課",
		"3550100":"所本部",
		"3550200":"新店區戶政事務所第一課",
		"3550300":"新店區戶政事務所第二課",
		"3550400":"新店區戶政事務所第三課",
		"3560000":"永和區戶政事務所",
		"3560100":"第一課",
		"3560200":"第二課",
		"3560300":"第三課",
		"3570000":"樹林區戶政事務所",
		"3570100":"所本部",
		"3570200":"第一課",
		"3570300":"第二課",
		"3570400":"第三課",
		"3580000":"鶯歌區戶政事務所",
		"3590000":"三峽區戶政事務所",
		"3600000":"汐止區戶政事務所",
		"3600200":"第一課",
		"3600300":"第二課",
		"3600400":"第三課",
		"3610000":"瑞芳鎮戶政事務所",
		"3610100":"所本部",
		"3610200":"主任室",
		"3620000":"淡水區戶政事務所",
		"3620100":"所本部",
		"3620300":"第一課",
		"3620400":"第二課",
		"3630000":"土城區戶政事務所",
		"3630100":"所本部",
		"3630200":"第一課",
		"3630300":"第二課",
		"3630400":"第三課",
		"3640100":"第一課",
		"3640200":"第二課",
		"3640300":"所本部",
		"3650000":"五股區戶政事務所",
		"3660000":"泰山區戶政事務所",
		"3670000":"林口區戶政事務所",
		"3680000":"八里區戶政事務所",
		"3690000":"深坑區戶政事務所",
		"3700000":"石碇區戶政事務所",
		"3710000":"坪林區戶政事務所",
		"3720000":"三芝區戶政事務所",
		"3730000":"石門區戶政事務所",
		"3740000":"金山區戶政事務所",
		"3750000":"萬里區戶政事務所",
		"3760000":"平溪區戶政事務所",
		"3770000":"雙溪區戶政事務所",
		"3770100":"所本部",
		"3780000":"貢寮區戶政事務所",
		"3790000":"烏來區戶政事務所",
		"4180200":"教保組",
		"4190200":"教保組",
		"4230100":"所本部",
		"4270100":"所本部",
		"4300200":"教保組",
		"901":"電力維護組",
		"90101":"電力維護單位",
		"902":"瓦斯維護組",
		"903":"臺北自來水組",
		"904":"省自來水組",
		"905":"電信維護組",
		"906":"後備指揮部",
		"9060000":"後備指揮部",
		"907":"臺北區監理所",
		"908":"石油維護組",
		"909":"第十河川局",
		"910":"北部巡防局",
		"9530116": "其它單位"
	};
	if (input == "" || input == null) {
		result = input2;
		if (result == undefined || result == null) {
			result = "其它單位(未登入名冊的單位)"
		}
	} else {
		input = String(input);
		if (input.length > 3 && lists[input.slice(0,3)] != undefined) {
			result = lists[input.slice(0,3)] + undefined_converter(lists[input]);
		} else {
			result = lists[input];
		}
	}
	if (result == undefined) { result = input }
	return result;
}

function radar_value_color_mapping(input){
	var key, result,
		colorList = {
			"0": { "R": 0, "G": 0.925490196, "B": 0.925490196, "alpha": "1" },
			"1": { "R": 0.000199923, "G": 0.91029604, "B": 0.927489427, "alpha": "1" },
			"2": { "R": 0.000399846, "G": 0.895101884, "B": 0.929488658, "alpha": "1" },
			"3": { "R": 0.000599769, "G": 0.879907728, "B": 0.931487889, "alpha": "1" },
			"4": { "R": 0.000799692, "G": 0.864713572, "B": 0.93348712, "alpha": "1" },
			"5": { "R": 0.000999616, "G": 0.849519416, "B": 0.935486351, "alpha": "1" },
			"6": { "R": 0.001199539, "G": 0.83432526, "B": 0.937485582, "alpha": "1" },
			"7": { "R": 0.001399462, "G": 0.819131103, "B": 0.939484814, "alpha": "1" },
			"8": { "R": 0.001599385, "G": 0.803936947, "B": 0.941484045, "alpha": "1" },
			"9": { "R": 0.001799308, "G": 0.788742791, "B": 0.943483276, "alpha": "1" },
			"10": { "R": 0.001999231, "G": 0.773548635, "B": 0.945482507, "alpha": "1" },
			"11": { "R": 0.002199154, "G": 0.758354479, "B": 0.947481738, "alpha": "1" },
			"12": { "R": 0.002399077, "G": 0.743160323, "B": 0.949480969, "alpha": "1" },
			"13": { "R": 0.002599, "G": 0.727966167, "B": 0.9514802, "alpha": "1" },
			"14": { "R": 0.002798923, "G": 0.712772011, "B": 0.953479431, "alpha": "1" },
			"15": { "R": 0.002998847, "G": 0.697577855, "B": 0.955478662, "alpha": "1" },
			"16": { "R": 0.00319877, "G": 0.682383699, "B": 0.957477893, "alpha": "1" },
			"17": { "R": 0.003398693, "G": 0.667189542, "B": 0.959477124, "alpha": "1" },
			"18": { "R": 0.003598616, "G": 0.651995386, "B": 0.961476355, "alpha": "1" },
			"19": { "R": 0.003798539, "G": 0.63680123, "B": 0.963475586, "alpha": "1" },
			"20": { "R": 0.003844675, "G": 0.61514802, "B": 0.964705882, "alpha": "1" },
			"21": { "R": 0.003644752, "G": 0.583160323, "B": 0.964705882, "alpha": "1" },
			"22": { "R": 0.003444829, "G": 0.551172626, "B": 0.964705882, "alpha": "1" },
			"23": { "R": 0.003244906, "G": 0.519184929, "B": 0.964705882, "alpha": "1" },
			"24": { "R": 0.003044983, "G": 0.487197232, "B": 0.964705882, "alpha": "1" },
			"25": { "R": 0.00284506, "G": 0.455209535, "B": 0.964705882, "alpha": "1" },
			"26": { "R": 0.002645136, "G": 0.423221838, "B": 0.964705882, "alpha": "1" },
			"27": { "R": 0.002445213, "G": 0.391234141, "B": 0.964705882, "alpha": "1" },
			"28": { "R": 0.00224529, "G": 0.359246444, "B": 0.964705882, "alpha": "1" },
			"29": { "R": 0.002045367, "G": 0.327258747, "B": 0.964705882, "alpha": "1" },
			"30": { "R": 0.001845444, "G": 0.29527105, "B": 0.964705882, "alpha": "1" },
			"31": { "R": 0.001645521, "G": 0.263283353, "B": 0.964705882, "alpha": "1" },
			"32": { "R": 0.001445598, "G": 0.231295656, "B": 0.964705882, "alpha": "1" },
			"33": { "R": 0.001245675, "G": 0.199307958, "B": 0.964705882, "alpha": "1" },
			"34": { "R": 0.001045752, "G": 0.167320261, "B": 0.964705882, "alpha": "1" },
			"35": { "R": 0.000845829, "G": 0.135332564, "B": 0.964705882, "alpha": "1" },
			"36": { "R": 0.000645905, "G": 0.103344867, "B": 0.964705882, "alpha": "1" },
			"37": { "R": 0.000445982, "G": 0.07135717, "B": 0.964705882, "alpha": "1" },
			"38": { "R": 0.000246059, "G": 0.039369473, "B": 0.964705882, "alpha": "1" },
			"39": { "R": 4.61e-5, "G": 0.007381776, "B": 0.964705882, "alpha": "1" },
			"40": { "R": 0, "G": 0, "B": 0.966089965, "alpha": "1" },
			"41": { "R": 0, "G": 0, "B": 0.967889273, "alpha": "1" },
			"42": { "R": 0, "G": 0, "B": 0.969688581, "alpha": "1" },
			"43": { "R": 0, "G": 0, "B": 0.971487889, "alpha": "1" },
			"44": { "R": 0, "G": 0, "B": 0.973287197, "alpha": "1" },
			"45": { "R": 0, "G": 0, "B": 0.975086505, "alpha": "1" },
			"46": { "R": 0, "G": 0, "B": 0.976885813, "alpha": "1" },
			"47": { "R": 0, "G": 0, "B": 0.978685121, "alpha": "1" },
			"48": { "R": 0, "G": 0, "B": 0.980484429, "alpha": "1" },
			"49": { "R": 0, "G": 0, "B": 0.982283737, "alpha": "1" },
			"50": { "R": 0, "G": 0, "B": 0.984083045, "alpha": "1" },
			"51": { "R": 0, "G": 0, "B": 0.985882353, "alpha": "1" },
			"52": { "R": 0, "G": 0, "B": 0.987681661, "alpha": "1" },
			"53": { "R": 0, "G": 0, "B": 0.989480969, "alpha": "1" },
			"54": { "R": 0, "G": 0, "B": 0.991280277, "alpha": "1" },
			"55": { "R": 0, "G": 0, "B": 0.993079585, "alpha": "1" },
			"56": { "R": 0, "G": 0, "B": 0.994878893, "alpha": "1" },
			"57": { "R": 0, "G": 0, "B": 0.996678201, "alpha": "1" },
			"58": { "R": 0, "G": 1, "B": 0, "alpha": "1" },
			"59": { "R": 0, "G": 0.998308343, "B": 0, "alpha": "1" },
			"60": { "R": 0, "G": 0.987312572, "B": 0, "alpha": "1" },
			"61": { "R": 0, "G": 0.976316801, "B": 0, "alpha": "1" },
			"62": { "R": 0, "G": 0.96532103, "B": 0, "alpha": "1" },
			"63": { "R": 0, "G": 0.95432526, "B": 0, "alpha": "1" },
			"64": { "R": 0, "G": 0.943329489, "B": 0, "alpha": "1" },
			"65": { "R": 0, "G": 0.932333718, "B": 0, "alpha": "1" },
			"66": { "R": 0, "G": 0.921337947, "B": 0, "alpha": "1" },
			"67": { "R": 0, "G": 0.910342176, "B": 0, "alpha": "1" },
			"68": { "R": 0, "G": 0.899346405, "B": 0, "alpha": "1" },
			"69": { "R": 0, "G": 0.888350634, "B": 0, "alpha": "1" },
			"70": { "R": 0, "G": 0.877354864, "B": 0, "alpha": "1" },
			"71": { "R": 0, "G": 0.866359093, "B": 0, "alpha": "1" },
			"72": { "R": 0, "G": 0.855363322, "B": 0, "alpha": "1" },
			"73": { "R": 0, "G": 0.844367551, "B": 0, "alpha": "1" },
			"74": { "R": 0, "G": 0.83337178, "B": 0, "alpha": "1" },
			"75": { "R": 0, "G": 0.822376009, "B": 0, "alpha": "1" },
			"76": { "R": 0, "G": 0.811380238, "B": 0, "alpha": "1" },
			"77": { "R": 0, "G": 0.800384468, "B": 0, "alpha": "1" },
			"78": { "R": 0, "G": 0.789388697, "B": 0, "alpha": "1" },
			"79": { "R": 0, "G": 0.778285275, "B": 0, "alpha": "1" },
			"80": { "R": 0, "G": 0.767089581, "B": 0, "alpha": "1" },
			"81": { "R": 0, "G": 0.755893887, "B": 0, "alpha": "1" },
			"82": { "R": 0, "G": 0.744698193, "B": 0, "alpha": "1" },
			"83": { "R": 0, "G": 0.733502499, "B": 0, "alpha": "1" },
			"84": { "R": 0, "G": 0.722306805, "B": 0, "alpha": "1" },
			"85": { "R": 0, "G": 0.711111111, "B": 0, "alpha": "1" },
			"86": { "R": 0, "G": 0.699915417, "B": 0, "alpha": "1" },
			"87": { "R": 0, "G": 0.688719723, "B": 0, "alpha": "1" },
			"88": { "R": 0, "G": 0.677524029, "B": 0, "alpha": "1" },
			"89": { "R": 0, "G": 0.666328335, "B": 0, "alpha": "1" },
			"90": { "R": 0, "G": 0.655132641, "B": 0, "alpha": "1" },
			"91": { "R": 0, "G": 0.643936947, "B": 0, "alpha": "1" },
			"92": { "R": 0, "G": 0.632741253, "B": 0, "alpha": "1" },
			"93": { "R": 0, "G": 0.621545559, "B": 0, "alpha": "1" },
			"94": { "R": 0, "G": 0.610349865, "B": 0, "alpha": "1" },
			"95": { "R": 0, "G": 0.599154171, "B": 0, "alpha": "1" },
			"96": { "R": 0, "G": 0.587958478, "B": 0, "alpha": "1" },
			"97": { "R": 0, "G": 0.576762784, "B": 0, "alpha": "1" },
			"98": { "R": 0, "G": 0.56556709, "B": 0, "alpha": "1" },
			"99": { "R": 0.047058824, "G": 0.585190311, "B": 0, "alpha": "1" },
			"100": { "R": 0.098039216, "G": 0.607381776, "B": 0, "alpha": "1" },
			"101": { "R": 0.149019608, "G": 0.629573241, "B": 0, "alpha": "1" },
			"102": { "R": 0.2, "G": 0.651764706, "B": 0, "alpha": "1" },
			"103": { "R": 0.250980392, "G": 0.673956171, "B": 0, "alpha": "1" },
			"104": { "R": 0.301960784, "G": 0.696147636, "B": 0, "alpha": "1" },
			"105": { "R": 0.352941176, "G": 0.7183391, "B": 0, "alpha": "1" },
			"106": { "R": 0.403921569, "G": 0.740530565, "B": 0, "alpha": "1" },
			"107": { "R": 0.454901961, "G": 0.76272203, "B": 0, "alpha": "1" },
			"108": { "R": 0.505882353, "G": 0.784913495, "B": 0, "alpha": "1" },
			"109": { "R": 0.556862745, "G": 0.80710496, "B": 0, "alpha": "1" },
			"110": { "R": 0.607843137, "G": 0.829296424, "B": 0, "alpha": "1" },
			"111": { "R": 0.658823529, "G": 0.851487889, "B": 0, "alpha": "1" },
			"112": { "R": 0.709803922, "G": 0.873679354, "B": 0, "alpha": "1" },
			"113": { "R": 0.760784314, "G": 0.895870819, "B": 0, "alpha": "1" },
			"114": { "R": 0.811764706, "G": 0.918062284, "B": 0, "alpha": "1" },
			"115": { "R": 0.862745098, "G": 0.940253749, "B": 0, "alpha": "1" },
			"116": { "R": 0.91372549, "G": 0.962445213, "B": 0, "alpha": "1" },
			"117": { "R": 0.964705882, "G": 0.984636678, "B": 0, "alpha": "1" },
			"118": { "R": 0.998523645, "G": 0.996124567, "B": 0, "alpha": "1" },
			"119": { "R": 0.99372549, "G": 0.983529412, "B": 0, "alpha": "1" },
			"120": { "R": 0.988927336, "G": 0.970934256, "B": 0, "alpha": "1" },
			"121": { "R": 0.984129181, "G": 0.9583391, "B": 0, "alpha": "1" },
			"122": { "R": 0.979331027, "G": 0.945743945, "B": 0, "alpha": "1" },
			"123": { "R": 0.974532872, "G": 0.933148789, "B": 0, "alpha": "1" },
			"124": { "R": 0.969734717, "G": 0.920553633, "B": 0, "alpha": "1" },
			"125": { "R": 0.964936563, "G": 0.907958478, "B": 0, "alpha": "1" },
			"126": { "R": 0.960138408, "G": 0.895363322, "B": 0, "alpha": "1" },
			"127": { "R": 0.955340254, "G": 0.882768166, "B": 0, "alpha": "1" },
			"128": { "R": 0.950542099, "G": 0.87017301, "B": 0, "alpha": "1" },
			"129": { "R": 0.945743945, "G": 0.857577855, "B": 0, "alpha": "1" },
			"130": { "R": 0.94094579, "G": 0.844982699, "B": 0, "alpha": "1" },
			"131": { "R": 0.936147636, "G": 0.832387543, "B": 0, "alpha": "1" },
			"132": { "R": 0.931349481, "G": 0.819792388, "B": 0, "alpha": "1" },
			"133": { "R": 0.926551326, "G": 0.807197232, "B": 0, "alpha": "1" },
			"134": { "R": 0.921753172, "G": 0.794602076, "B": 0, "alpha": "1" },
			"135": { "R": 0.916955017, "G": 0.78200692, "B": 0, "alpha": "1" },
			"136": { "R": 0.912156863, "G": 0.769411765, "B": 0, "alpha": "1" },
			"137": { "R": 0.907358708, "G": 0.756816609, "B": 0, "alpha": "1" },
			"138": { "R": 0.909204152, "G": 0.746297578, "B": 0, "alpha": "1" },
			"139": { "R": 0.914002307, "G": 0.736701269, "B": 0, "alpha": "1" },
			"140": { "R": 0.918800461, "G": 0.72710496, "B": 0, "alpha": "1" },
			"141": { "R": 0.923598616, "G": 0.717508651, "B": 0, "alpha": "1" },
			"142": { "R": 0.92839677, "G": 0.707912341, "B": 0, "alpha": "1" },
			"143": { "R": 0.933194925, "G": 0.698316032, "B": 0, "alpha": "1" },
			"144": { "R": 0.93799308, "G": 0.688719723, "B": 0, "alpha": "1" },
			"145": { "R": 0.942791234, "G": 0.679123414, "B": 0, "alpha": "1" },
			"146": { "R": 0.947589389, "G": 0.669527105, "B": 0, "alpha": "1" },
			"147": { "R": 0.952387543, "G": 0.659930796, "B": 0, "alpha": "1" },
			"148": { "R": 0.957185698, "G": 0.650334487, "B": 0, "alpha": "1" },
			"149": { "R": 0.961983852, "G": 0.640738178, "B": 0, "alpha": "1" },
			"150": { "R": 0.966782007, "G": 0.631141869, "B": 0, "alpha": "1" },
			"151": { "R": 0.971580161, "G": 0.621545559, "B": 0, "alpha": "1" },
			"152": { "R": 0.976378316, "G": 0.61194925, "B": 0, "alpha": "1" },
			"153": { "R": 0.981176471, "G": 0.602352941, "B": 0, "alpha": "1" },
			"154": { "R": 0.985974625, "G": 0.592756632, "B": 0, "alpha": "1" },
			"155": { "R": 0.99077278, "G": 0.583160323, "B": 0, "alpha": "1" },
			"156": { "R": 0.995570934, "G": 0.573564014, "B": 0, "alpha": "1" },
			"157": { "R": 1, "G": 0.562491349, "B": 0, "alpha": "1" },
			"158": { "R": 1, "G": 0.533702422, "B": 0, "alpha": "1" },
			"159": { "R": 1, "G": 0.504913495, "B": 0, "alpha": "1" },
			"160": { "R": 1, "G": 0.476124567, "B": 0, "alpha": "1" },
			"161": { "R": 1, "G": 0.44733564, "B": 0, "alpha": "1" },
			"162": { "R": 1, "G": 0.418546713, "B": 0, "alpha": "1" },
			"163": { "R": 1, "G": 0.389757785, "B": 0, "alpha": "1" },
			"164": { "R": 1, "G": 0.360968858, "B": 0, "alpha": "1" },
			"165": { "R": 1, "G": 0.332179931, "B": 0, "alpha": "1" },
			"166": { "R": 1, "G": 0.303391003, "B": 0, "alpha": "1" },
			"167": { "R": 1, "G": 0.274602076, "B": 0, "alpha": "1" },
			"168": { "R": 1, "G": 0.245813149, "B": 0, "alpha": "1" },
			"169": { "R": 1, "G": 0.217024221, "B": 0, "alpha": "1" },
			"170": { "R": 1, "G": 0.188235294, "B": 0, "alpha": "1" },
			"171": { "R": 1, "G": 0.159446367, "B": 0, "alpha": "1" },
			"172": { "R": 1, "G": 0.130657439, "B": 0, "alpha": "1" },
			"173": { "R": 1, "G": 0.101868512, "B": 0, "alpha": "1" },
			"174": { "R": 1, "G": 0.073079585, "B": 0, "alpha": "1" },
			"175": { "R": 1, "G": 0.044290657, "B": 0, "alpha": "1" },
			"176": { "R": 1, "G": 0.01550173, "B": 0, "alpha": "1" },
			"177": { "R": 0.99621684, "G": 0, "B": 0, "alpha": "1" },
			"178": { "R": 0.988019992, "G": 0, "B": 0, "alpha": "1" },
			"179": { "R": 0.979823145, "G": 0, "B": 0, "alpha": "1" },
			"180": { "R": 0.971626298, "G": 0, "B": 0, "alpha": "1" },
			"181": { "R": 0.96342945, "G": 0, "B": 0, "alpha": "1" },
			"182": { "R": 0.955232603, "G": 0, "B": 0, "alpha": "1" },
			"183": { "R": 0.947035755, "G": 0, "B": 0, "alpha": "1" },
			"184": { "R": 0.938838908, "G": 0, "B": 0, "alpha": "1" },
			"185": { "R": 0.930642061, "G": 0, "B": 0, "alpha": "1" },
			"186": { "R": 0.922445213, "G": 0, "B": 0, "alpha": "1" },
			"187": { "R": 0.914248366, "G": 0, "B": 0, "alpha": "1" },
			"188": { "R": 0.906051519, "G": 0, "B": 0, "alpha": "1" },
			"189": { "R": 0.897854671, "G": 0, "B": 0, "alpha": "1" },
			"190": { "R": 0.889657824, "G": 0, "B": 0, "alpha": "1" },
			"191": { "R": 0.881460977, "G": 0, "B": 0, "alpha": "1" },
			"192": { "R": 0.873264129, "G": 0, "B": 0, "alpha": "1" },
			"193": { "R": 0.865067282, "G": 0, "B": 0, "alpha": "1" },
			"194": { "R": 0.856870434, "G": 0, "B": 0, "alpha": "1" },
			"195": { "R": 0.848673587, "G": 0, "B": 0, "alpha": "1" },
			"196": { "R": 0.84047674, "G": 0, "B": 0, "alpha": "1" },
			"197": { "R": 0.835494041, "G": 0, "B": 0, "alpha": "1" },
			"198": { "R": 0.831095732, "G": 0, "B": 0, "alpha": "1" },
			"199": { "R": 0.826697424, "G": 0, "B": 0, "alpha": "1" },
			"200": { "R": 0.822299116, "G": 0, "B": 0, "alpha": "1" },
			"201": { "R": 0.817900807, "G": 0, "B": 0, "alpha": "1" },
			"202": { "R": 0.813502499, "G": 0, "B": 0, "alpha": "1" },
			"203": { "R": 0.809104191, "G": 0, "B": 0, "alpha": "1" },
			"204": { "R": 0.804705882, "G": 0, "B": 0, "alpha": "1" },
			"205": { "R": 0.800307574, "G": 0, "B": 0, "alpha": "1" },
			"206": { "R": 0.795909266, "G": 0, "B": 0, "alpha": "1" },
			"207": { "R": 0.791510957, "G": 0, "B": 0, "alpha": "1" },
			"208": { "R": 0.787112649, "G": 0, "B": 0, "alpha": "1" },
			"209": { "R": 0.782714341, "G": 0, "B": 0, "alpha": "1" },
			"210": { "R": 0.778316032, "G": 0, "B": 0, "alpha": "1" },
			"211": { "R": 0.773917724, "G": 0, "B": 0, "alpha": "1" },
			"212": { "R": 0.769519416, "G": 0, "B": 0, "alpha": "1" },
			"213": { "R": 0.765121107, "G": 0, "B": 0, "alpha": "1" },
			"214": { "R": 0.760722799, "G": 0, "B": 0, "alpha": "1" },
			"215": { "R": 0.756324491, "G": 0, "B": 0, "alpha": "1" },
			"216": { "R": 0.755847751, "G": 0, "B": 0.011764706, "alpha": "1" },
			"217": { "R": 0.768442907, "G": 0, "B": 0.062745098, "alpha": "1" },
			"218": { "R": 0.781038062, "G": 0, "B": 0.11372549, "alpha": "1" },
			"219": { "R": 0.793633218, "G": 0, "B": 0.164705882, "alpha": "1" },
			"220": { "R": 0.806228374, "G": 0, "B": 0.215686275, "alpha": "1" },
			"221": { "R": 0.818823529, "G": 0, "B": 0.266666667, "alpha": "1" },
			"222": { "R": 0.831418685, "G": 0, "B": 0.317647059, "alpha": "1" },
			"223": { "R": 0.844013841, "G": 0, "B": 0.368627451, "alpha": "1" },
			"224": { "R": 0.856608997, "G": 0, "B": 0.419607843, "alpha": "1" },
			"225": { "R": 0.869204152, "G": 0, "B": 0.470588235, "alpha": "1" },
			"226": { "R": 0.881799308, "G": 0, "B": 0.521568627, "alpha": "1" },
			"227": { "R": 0.894394464, "G": 0, "B": 0.57254902, "alpha": "1" },
			"228": { "R": 0.906989619, "G": 0, "B": 0.623529412, "alpha": "1" },
			"229": { "R": 0.919584775, "G": 0, "B": 0.674509804, "alpha": "1" },
			"230": { "R": 0.932179931, "G": 0, "B": 0.725490196, "alpha": "1" },
			"231": { "R": 0.944775087, "G": 0, "B": 0.776470588, "alpha": "1" },
			"232": { "R": 0.957370242, "G": 0, "B": 0.82745098, "alpha": "1" },
			"233": { "R": 0.969965398, "G": 0, "B": 0.878431373, "alpha": "1" },
			"234": { "R": 0.982560554, "G": 0, "B": 0.929411765, "alpha": "1" },
			"235": { "R": 0.995155709, "G": 0, "B": 0.980392157, "alpha": "1" },
			"236": { "R": 0.98745098, "G": 0.010457516, "B": 0.993356401, "alpha": "1" },
			"237": { "R": 0.967058824, "G": 0.02745098, "B": 0.982560554, "alpha": "1" },
			"238": { "R": 0.946666667, "G": 0.044444444, "B": 0.971764706, "alpha": "1" },
			"239": { "R": 0.92627451, "G": 0.061437908, "B": 0.960968858, "alpha": "1" },
			"240": { "R": 0.905882353, "G": 0.078431373, "B": 0.95017301, "alpha": "1" },
			"241": { "R": 0.885490196, "G": 0.095424837, "B": 0.939377163, "alpha": "1" },
			"242": { "R": 0.865098039, "G": 0.112418301, "B": 0.928581315, "alpha": "1" },
			"243": { "R": 0.844705882, "G": 0.129411765, "B": 0.917785467, "alpha": "1" },
			"244": { "R": 0.824313725, "G": 0.146405229, "B": 0.906989619, "alpha": "1" },
			"245": { "R": 0.803921569, "G": 0.163398693, "B": 0.896193772, "alpha": "1" },
			"246": { "R": 0.783529412, "G": 0.180392157, "B": 0.885397924, "alpha": "1" },
			"247": { "R": 0.763137255, "G": 0.197385621, "B": 0.874602076, "alpha": "1" },
			"248": { "R": 0.742745098, "G": 0.214379085, "B": 0.863806228, "alpha": "1" },
			"249": { "R": 0.722352941, "G": 0.231372549, "B": 0.853010381, "alpha": "1" },
			"250": { "R": 0.701960784, "G": 0.248366013, "B": 0.842214533, "alpha": "1" },
			"251": { "R": 0.681568627, "G": 0.265359477, "B": 0.831418685, "alpha": "1" },
			"252": { "R": 0.661176471, "G": 0.282352941, "B": 0.820622837, "alpha": "1" },
			"253": { "R": 0.640784314, "G": 0.299346405, "B": 0.80982699, "alpha": "1" },
			"254": { "R": 0.620392157, "G": 0.316339869, "B": 0.799031142, "alpha": "1" },
			"255": { "R": 0.6, "G": 0.333333333, "B": 0.788235294, "alpha": "1" }
		}
	if (input >= 65) {
		key = '255'
	} else {
		key = String((input * 4)-1)
	}
	result = 'rgb(' + Math.floor(colorList[key]["R"]*255) + ',' + Math.floor(colorList[key]["G"]*255) + ',' + Math.floor(colorList[key]["B"]*255) + ')'
	return result
}

function highchartStackedSortRedraw(chartSource) {
	var series = chartSource.series;
	var axis = chartSource.xAxis[0];
	var categories = [];

	if($.isArray(series)) {
		var ser = $.grep(series, function(ser, seriesIndex) {
			return ser.visible;
		})[0];
		$.each(ser.data, function(dataIndex, datum) {
			var obj = {
				name: datum.category,
				index: dataIndex,
				stackTotal: datum.stackTotal
			}
			categories.push(obj);
		});
	}

	categories.sort(function(a, b) {
		var aName = a.name.toLowerCase();
		var bName = b.name.toLowerCase();
		var aTotal = a.stackTotal;
		var bTotal = b.stackTotal;
		if(aTotal === bTotal) {
			return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
		} else {
			return ((aTotal > bTotal) ? -1 : ((aTotal < bTotal) ? 1 : 0));
		}
	});

	var mappedIndex = $.map(categories, function(category, index) {
		return category.index;
	});

	categories = $.map(categories, function(category, index) {
		return category.name;
	});

	axis.setCategories(categories);

	$.each(series, function(seriesIndex, ser) {
		var data = $.map(mappedIndex, function(mappedIndex, origIndex) {
			return ser.data[mappedIndex].y;
		});
		ser.setData(data);
	});
};

function stacked_chart(input){
	if (input.legend === undefined) {
		input.legend = true
	}
	if (input.title === undefined) {
		input.title = ''
	}
	var category_array = Object.keys(input.data[0]), dataset = [], index = 0, array_list = {};
	input.key_name.forEach(function(element){
		array_list[element] = [];
	});
	input.data.forEach((eachSeries, index) => {
		Object.keys(eachSeries).forEach((eachCategoryKey) => {
			var valueKeyName = input.key_name[index]
			array_list[valueKeyName].push(eachSeries[eachCategoryKey][valueKeyName])
		})
	})
	for (var element in array_list) {
		dataset.push({
	        name: input.label[index],
	        color: input.color[index],
	        data: array_list[element]
		})
		index += 1;
	}
	Highcharts.chart(input.div, {
	    chart: {
	        type: 'column'
	    },
	    title: {
	        text: input.title
	    },
	    xAxis: {
	        categories: category_array,
            labels: {
                step: 1,
                style: {
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 1)',
                    fontSize: '12px'
                },
                useHTML: true,
                formatter: function(){
					var string = "";
					for(var i = 0; i < this.value.length; i++){
						string += this.value.slice(i, (i+1)) + "<br>";
					}
                    return string;
                }
            }
	    },
	    yAxis: {
			allowDecimals: false,
	        min: 0,
	        title: {
	            text: ''
	        },
            labels: {
                useHTML: true,
                formatter: function(){
                    var string = this.value + input.yAxisLabel
                    return string;
                }
            },
			stackLabels: {
				enabled: true,
				style: {
					fontWeight: 'bold',
					color: 'rgba(0, 0, 0, 1)'
				}
			}
	    },
	    tooltip: {
	        pointFormat: '<span>{series.name}</span>: <b>{point.y}' + input.yAxisLabel + '</b> ({point.percentage:.0f}%)<br/>',
	        shared: true
	    },
	    exporting: {
	    	enabled: true
	    },
	    plotOptions: {
	        column: {
				stacking: input.stackingType,
				cursor: input.cursor || (input.cursor = 'default'),
	        },
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                        	var query_condition = this.category;
                        	input.click_event_binding(query_condition);
                        }
                    }
                }
            }
	    },
		legend: {
			enabled: input.legend
		},
	    series: dataset
	}, function(chart) {
		if (!input.redrawNoTrigger) {
			highchartStackedSortRedraw(chart)
		}
	});
}

function stacked_chart_for_earthquake_topic(input){
	if (input.legend === undefined) {
		input.legend = true
	}
	if (input.title === undefined) {
		input.title = ''
	}
	var category_array = Object.keys(input.data[0]), dataset = [], array_list = {};
	input.key_name.forEach(function(element){
		array_list[element] = [];
	});
	Object.values(input.data[0]).forEach((eachSeries) => {
		Object.keys(eachSeries).forEach((eachCategoryKey) => {
			if (eachCategoryKey !== "sum") {
				array_list[eachCategoryKey].push(eachSeries[eachCategoryKey])
			}
		})
	})
	Object.keys(array_list).forEach((key, index) => {
		dataset.push({
	        name: input.label[index],
	        data: array_list[key]
		})
	})
	Highcharts.chart(input.div, {
	    chart: {
	        type: 'column'
	    },
	    title: {
	        text: input.title
	    },
	    xAxis: {
	        categories: category_array,
            labels: {
                step: 1,
                style: {
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 1)',
                    fontSize: '12px'
                },
                useHTML: true,
                formatter: function(){
					var string = "";
					for(var i = 0; i < this.value.length; i++){
						string += this.value.slice(i, (i+1)) + "<br>";
					}
                    return string;
                }
            }
	    },
	    yAxis: {
			allowDecimals: false,
	        min: 0,
	        title: {
	            text: ''
	        },
            labels: {
                useHTML: true,
                formatter: function(){
                    var string = this.value + input.yAxisLabel
                    return string;
                }
            },
			stackLabels: {
				enabled: true,
				style: {
					fontWeight: 'bold',
					color: 'rgba(0, 0, 0, 1)'
				}
			}
	    },
	    tooltip: {
	        pointFormat: '<span>{series.name}</span>: <b>{point.y}' + input.yAxisLabel + '</b> ({point.percentage:.0f}%)<br/>',
	        shared: true
	    },
	    exporting: {
	    	enabled: true
	    },
	    plotOptions: {
	        column: {
				stacking: input.stackingType,
				cursor: input.cursor || (input.cursor = 'default'),
	        },
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                        	var query_condition = this.category;
                        	input.click_event_binding(query_condition);
                        }
                    }
                }
            }
	    },
		legend: {
			enabled: input.legend
		},
	    series: dataset
	}, function(chart) {
		if (!input.redrawNoTrigger) {
			highchartStackedSortRedraw(chart)
		}
	});
}

function pie_chart(data_input, option){
	var type_Sorted = Object.keys(data_input).sort(function(a,b){ return data_input[b]-data_input[a]});
	var chart_array_disatype = [];
	type_Sorted.forEach(function(element){
		chart_array_disatype.push({
			name: element,
			y: data_input[element]
		})
	})
	var pieColors = get_red_color_schema(Object.keys(data_input))
	Highcharts.chart(option.renderDiv, {
		chart: {
			type: 'pie'
		},
		title: {
			text: ''
		},
		tooltip: {
			useHTML: true,
			headerFormat: '<span class="font-size-16p">{point.key}</span><br>',
			pointFormat: '{series.name} <b>{point.percentage:.1f}%</b><br>' + option.subtitle + '： <b>{point.y}' + option.unit + '</b>'
		},
		plotOptions: {
			pie: {
				cursor: option.cursor || (option.cursor = 'default'),
				colors: pieColors,
				borderWidth: 0,
				dataLabels: {
					enabled: true,
					distance: -20,
					filter: {
						property: 'percentage',
						operator: '>',
						value: 4
					},
					style: {
						fontWeight: 'bold',
					},
					formatter: function(){
						var string;
						string = '<span class="font-size-16p">' + this.key + '<br>占' + this.percentage.toFixed(0) + "%<br>(" + this.y + option.unit + ")</span>";
						return string;
					}
				}
			},
			series: {
				allowPointSelect: true,
				// cursor: 'pointer',
				point: {
					events: {
						click: function(){}
					}
				}
			}
		},
		series: [{
			name: '比例：',
			data: chart_array_disatype
		}]
	})
}

function pie_chart_advanced(option) {
	Highcharts.chart(option.renderdiv, {
		chart: {
			plotBackgroundColor: null,
			plotBorderWidth: null,
			plotShadow: false,
			type: 'pie'
		},
		title: {
			text: option.title,
			style: { "fontSize": "16px" }
		},
		tooltip: {
			pointFormat: option.tooltipPointFormat
		},
		accessibility: {
			point: {
				valueSuffix: '%'
			}
		},
		plotOptions: {
			pie: {
				allowPointSelect: true,
				cursor: 'pointer',
				dataLabels: {
					enabled: true,
					format: option.dataLabelsFormat,
					formatter: option.dataLabelsFormatter,
					color: '#000000',
					connectorColor: '#000000',
					padding: 0
				}
			}
		},
		series: [{
			name: option.series.name,
			colorByPoint: true,
			data: option.series.data,
			events: option.series.events
		}]
	})
}

function geoJsonTemplate(){
	this.type = "FeatureCollection"
	this.features = []
}

function get_red_color_schema(array){
	var colors = [], colors_list = ['#8b0000','#9e061c','#b11631','#bf2744','#ce3856','#da4967','#e45c78','#ee6e87','#f58096','#fb93a3','#ffa6b0','#ffbbbd','#ffcec8','#ffe3d3','#fff5dc','#fbffdd','#f4fdd7','#edfcd2','#e6fccd','#dffbc7','#d8fac2','#d0f8bc','#c8f7b7','#c0f6b1','#b8f4ab','#b2f4a7','#a9f2a1','#a0f19a','#99ef96','#90ee90'], interval = Math.round(40 / array.length);
	if (array.length > 5) {
		interval = Math.round((interval/2));
	}
	for (var i = 0; i < 40; i += interval) {
		if (colors_list[i] == undefined) {
			colors.push('#f0f5f9');
		} else {
			colors.push(colors_list[i]);
		}
	}
	return colors
}

function zoomToRegionMap(query_condition){
	var target_geojson
	overlay_dataset["Basic_map"].features.forEach(function(element){
		if (element.properties.TOWNNAME == query_condition) {
			target_geojson = element;
		}
	});
	if (overlay_dataset["temp_map"] != undefined) {
		map.removeLayer(overlay_dataset["temp_map"]);
	};
	overlay_dataset["temp_map"] = L.geoJson(target_geojson,{
		color: "#ef5285",
		weight: 3,
		fill: false,
		interactive: false
	}).addTo(map);
	map.fitBounds(overlay_dataset["temp_map"].getBounds());
	setTimeout(function(){
		map.panBy([-90, 0]);
	}, 500);
}

function wmsQueryBBoxString(event){
	var coor = event.latlng, zoom = event.target._zoom, weightValue, string
	if (zoom >= 20) {
		weightValue = 0.000002 * (23 - zoom)
	} else if (zoom > 15) {
		weightValue = 0.00001 * (23 - zoom)
	} else if (zoom > 12) {
		weightValue = 0.0001 * (30 - zoom/2)
	} else {
		weightValue = 0.0005 * (30 - zoom)
	}
	string =
		(coor.lng - weightValue) + '%20' + (coor.lat - weightValue) + ',%20' +
		(coor.lng - weightValue) + '%20' + (coor.lat + weightValue) + ',%20' +
		(coor.lng + weightValue) + '%20' + (coor.lat + weightValue) + ',%20' +
		(coor.lng + weightValue) + '%20' + (coor.lat - weightValue) + ',%20' +
		(coor.lng - weightValue) + '%20' + (coor.lat - weightValue)

	// let polygonLatLng = [
	// 	[coor.lng - weightValue, coor.lat - weightValue].reverse(),
	// 	[coor.lng - weightValue, coor.lat + weightValue].reverse(),
	// 	[coor.lng + weightValue, coor.lat + weightValue].reverse(),
	// 	[coor.lng + weightValue, coor.lat - weightValue].reverse(),
	// 	[coor.lng - weightValue, coor.lat - weightValue].reverse()
	// ]
	// L.polygon(polygonLatLng, {color: 'red'}).addTo(map)

	return string
}

function wmsInfoDialog(e, url){
	var bboxString = wmsQueryBBoxString(e),
		request = url.front + bboxString + url.back
	console.log(request)
	loader_asynchronous(function(){
		var data = ajax_call(request), html = ""
		if (data.features.length > 0) {
			let sizeunit = ''
			if (data.features[0].properties.pipeid) {
				let manage = '', start_depth = '', end_depth = ''
				if (data.features[0].properties.properties) {
					sizeunit = unitMapping(JSON.parse(data.features[0].properties.properties)?.SizeUnit)
					manage = manageMapping(url.layerName, JSON.parse(data.features[0].properties.properties)?.Organ)
					start_depth = JSON.parse(data.features[0].properties.properties).StartDepth
					end_depth = JSON.parse(data.features[0].properties.properties).EndDepth
				} else {
					sizeunit = unitMapping(data.features[0].properties?.sizeunit)
					manage = manageMapping(url.layerName, data.features[0].properties?.organ)
					start_depth = data.features[0].properties.startdepth
					end_depth = data.features[0].properties.enddepth
				}
				html += `<tr><td>管理單位</td><td>${manage}</td></tr>`
				html += `<tr><td>起點埋設深度</td><td>${start_depth} m</td></tr>`
				html += `<tr><td>終點埋設深度</td><td>${end_depth} m</td></tr>`
			}
			if (!url.keyMeta) {
				Object.keys(data.features[0].properties).forEach(function(key){
					let unit = ''
					if (key == '寬度') unit = sizeunit
					else if (key == '長度')	unit = 'm'
					html += `<tr><td>${key}</td><td>${data.features[0].properties[key] ?? '-'} ${unit}</td></tr>`
				})
			} else {
				Object.keys(url.keyMeta).forEach(function(key){
					let unit = ''
					if (url.keyMeta[key] == '寬度') unit = sizeunit
					else if (url.keyMeta[key].includes('寬度') || url.keyMeta[key].includes('長度')) unit = 'm'
					html += `<tr><td>${url.keyMeta[key]}</td><td>${data.features[0].properties[key] ?? '-'} ${unit}</td></tr>`
				})
			}
			modal_open(
				'<div class="w-100 h-300" id="modal_map"></div><table class="table table-sm table-bordered w-100"> <thead class="thead-dark"><tr><th>欄位名稱</th><th>欄位值</th></tr></thead><tbody>' + html + '</tbody></table>',
				"圖層欄位檢視(" + url.layerName + ")"
			)
			setTimeout(function(){
				var modal_map = new L.Map('modal_map', {
						attributionControl: false,
						zoomControl: false,
						center: new L.LatLng(e.latlng.lat, e.latlng.lng),
						zoom: 18,
						zoomSnap: 1,
						layers: L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
							maxZoom: 22,
							subdomains:['mt0','mt1','mt2','mt3'],
							opacity: 0.8
						})
					}),
					thisLayer = L.geoJson(data.features[0]).addTo(modal_map)
				if (data.features[0].geometry.type.match("LineString")) {
					modal_map.fitBounds(thisLayer.getBounds())
				} else {
					modal_map.setView([data.features[0].geometry.coordinates[0][1], data.features[0].geometry.coordinates[0][0]], 18)
				}
			}, 1000)
		}
	})
}

function mapLoadingState(state){
    switch(state){
        case "normal":
            $("#map").css("pointer-events", "unset")
            $("body").removeClass("body-wait")
            break
        case "loading":
            $("#map").css("pointer-events", "none")
            $("body").addClass("body-wait")
            break
    }
}

function wmsTileLayerInfo(e){
	if (wmsQueryTargetList.length > 0) {
		mapLoadingState("loading")
	}
    var dataType = {geojson: "application%2Fjson", jsonp: "text%2Fjavascript"}
    wmsQueryTargetList.forEach(function(element){
        wmsInfoPopupNormal(e, {
            front: element.url.replace("/wms?", "/ows?") + "service=WFS&version=1.0.0&request=GetFeature&typeName=" + element.option.layer + "&cql_filter=INTERSECTS(" + element.option.geoFieldName + ",%20POLYGON((",
            back: ")))&outputFormat=" + dataType[element.option.method.name],
            layerName: element.option.name,
			query: element.option.method,
			field: element.option.field
        })
    })
}

function wmsInfoPopupNormal(e, url){
    $(".leaflet-pane.leaflet-popup-pane").html("")
    var bboxString = wmsQueryBBoxString(e), request = url.front + bboxString + url.back
    if (url.query.name == "geojson") {
        ajax_call_async(request, function(data){
            wmsPopupEvent(url.layerName, data)
        })
    } else {
        ajax_call_jsonp(request, url.query.keyWord,
            function(data){
                wmsPopupEvent(url.layerName, data)
            },
            function(){
                mapLoadingState("normal")
            }
        )
    }

    function wmsPopupEvent(title, data){
        var data, html = '<h5 class="font-weight-bold">' + title + '</h5>'
		if (data.features.length > 0) {
			let sizeunit = '', manage = '', start_depth = '', end_depth = ''
			if (title.includes('管線')) {
				if (data.features[0].properties.properties) {
					sizeunit = unitMapping(JSON.parse(data.features[0].properties.properties)?.SizeUnit)
					manage = manageMapping(title, JSON.parse(data.features[0].properties.properties)?.Organ)
					start_depth = JSON.parse(data.features[0].properties.properties).StartDepth
					end_depth = JSON.parse(data.features[0].properties.properties).EndDepth
				} else {
					sizeunit = unitMapping(data.features[0].properties?.sizeunit)
					manage = manageMapping(title, data.features[0].properties?.organ)
					start_depth = data.features[0].properties.startdepth
					end_depth = data.features[0].properties.enddepth
				}
				html += `<h6>管理單位：${manage}</h6>`
				html += `<h6>起點埋設深度：${start_depth} m</h6>`
				html += `<h6>終點埋設深度：${end_depth} m</h6>`
			}
			if (url.field) {
				var fieldList = Object.keys(url.field)
				Object.keys(data.features[0].properties).forEach(function(key){
					if (fieldList.includes(key)){
						let unit = ''
						if (url.field[key] == '寬度') unit = sizeunit
						else if (url.field[key] == '長度') unit = 'm'
						html += `<h6>${url.field[key]}：${null_Converter_v2(data.features[0].properties[key])} ${unit}</h6>`
					}
				})
			} else {
				Object.keys(data.features[0].properties).forEach(function(key){
					let unit = ''
					if (key == '寬度' || key == '深度') unit = sizeunit
					else if (key == '長度') unit = 'm'
					html += `<h6>${key}：${null_Converter_v2(data.features[0].properties[key])} ${unit}</h6>`
				})
			}
            if ($("#wmsQueryInfoDiv").length == 0) {
                var popup = L.popup()
                    .setLatLng(e.latlng)
                    .setContent('<div class="overflow-auto mostly-customized-scrollbar" id="wmsQueryInfoDiv">' + html + '</div>')
                    .openOn(map)
                mapLoadingState("normal")
            } else {
                setTimeout(function(){
                    $("#wmsQueryInfoDiv").append('<div class="mt-3">' + html + '</div>')
                }, 1000)
            }
		} else {
            mapLoadingState("normal")
        }
    }
}

function googleSearchInfo(data){
	var this_object, news_string, this_url, this_title, block_div
	if (data != null) {
		if (data.length != 0) {
			data.forEach(function(element, index){
				if (index == 0) {
					block_div = "<div>";
				} else {
					block_div = '<div class="mt-2">';
				}
				this_object = $(element);
				this_url = $('a', this_object).attr("href");
				this_url = this_url.split("&sa=");
				this_url = this_url[0].replace("/url?q=", "");
				$('a', this_object).attr("href", this_url);
				$('a', this_object).attr("target", "_blank");
				$('a', this_object).removeAttr("ping");
				$('.B6fmyf', this_object).eq(0).remove();
				this_title = $('h3', this_object).html();
				$('h3', this_object).html("(" + (index+1) + ")" + this_title);
				$('h3', this_object).css("margin", "0px");
				news_string += block_div + this_object.html() + '</div>';
			});
		} else {
			news_string = '<h4 class="text-center">-查無結果-</h4>';
		}
	} else {
		news_string = '<h4 class="text-center">-查無結果-</h4>';
	}
	return news_string.replace("undefined", "")
}

function jwtLogout(){
	localStorage.removeItem('jwt_token');
	localStorage.removeItem('jwt_token_swagger');
	location.assign(location.origin + location.pathname);
}

function emisEventPointOpenInTopic(){
	if (emis_event_select) {
		backgroud_layer_control("重大災情");
		backgroud_layer_control("一般災情");
	}
}

function stacked_percent_chart(input){
	var category_array = Object.keys(input.data), dataset = [], index = 0;
	var array_list = {};
	input.key_name.forEach(function(element){
		array_list[element] = [];
	});
	for (var element in input.data) {
		for (var key in array_list) {
			array_list[key].push(input.data[element][key]);
		}
	}

	for (var element in array_list) {
		dataset.push({
	        name: input.label[index],
	        color: input.color[index],
	        data: array_list[element]
		})
		index += 1;
	}

	Highcharts.chart(input.div, {
	    chart: {
	        type: 'column'
	    },
	    title: {
	        text: ''
	    },
	    xAxis: {
	        categories: category_array,
            labels: {
                step: 1,
                style: {
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 1)',
                    fontSize: '12px'
                },
                useHTML: true,
                formatter: function(){
                    var string = this.value.slice(0, 1) + "<br>" + this.value.slice(1, 2) + "<br>" + this.value.slice(2, 3)
                    return string;
                }
            }
	    },
	    yAxis: {
	        min: 0,
	        title: {
	            text: ''
	        },
            labels: {
                useHTML: true,
                formatter: function(){
                    var string = this.value + "%"
                    return string;
                }
            }
	    },
	    tooltip: {
	        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}處</b> ({point.percentage:.0f}%)<br/>',
	        shared: true
	    },
	    exporting: {
	    	enabled: false
	    },
	    plotOptions: {
	        column: {
				stacking: 'percent'
	        },
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
							var query_condition = this.category
							zoomToRegionMap(query_condition)
                        }
                    }
                }
            }
	    },
	    series: dataset
	}, function(chart) {
		if (!input.redrawNoTrigger) {
			highchartStackedSortRedraw(chart)
		}
	})
}

function stacked_column_chart(input){
	var category_array = Object.keys(input.data), dataset = [], index = 0;
	var array_list = {};
	input.key_name.forEach(function(element){
		array_list[element] = [];
	});
	for (var element in input.data) {
		for (var key in array_list) {
			array_list[key].push(input.data[element][key]);
		}
	}
	for (var element in array_list) {
		dataset.push({
	        name: input.label[index],
	        color: input.color[index],
	        data: array_list[element]
		})
		index += 1;
	}

	Highcharts.chart(input.div, {
	    chart: {
	        type: 'column'
	    },
	    title: {
	        text: ''
	    },
	    xAxis: {
	        categories: category_array,
            labels: {
                step: 1,
                style: {
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 1)',
                    fontSize: '12px'
                },
                useHTML: true,
                formatter: function(){
                    var string = this.value.slice(0, 1) + "<br>" + this.value.slice(1, 2) + "<br>" + this.value.slice(2, 3)
                    return string;
                }
            }
	    },
	    yAxis: {
	        min: 0,
			max: input.max,
	        title: {
	            text: ''
	        },
            labels: {
                useHTML: true,
                formatter: function(){
                    var string = this.value + "處"
                    return string;
                }
            }
	    },
	    tooltip: {
	        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}處</b> ({point.percentage:.0f}%)<br/>',
	        shared: true
	    },
	    exporting: {
	    	enabled: false
	    },
	    plotOptions: {
	        column: {
				stacking: 'normal',
				dataLabels: {
					enabled: false,
					color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
				}
	        },
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
							var query_condition = this.category
							zoomToRegionMap(query_condition)
                        }
                    }
                }
            }
	    },
	    series: dataset
	}, function(chart) {
		if (!input.redrawNoTrigger) {
			highchartStackedSortRedraw(chart)
		}
	})
}

function mobile_pump_status_handler(value){
	var result;
	switch(value){
		case "抽水中":
			result = "work";
			break;
		case "待命":
			result = "standby";
			break;
		case "運送中":
			result = "moving";
			break;
		case "離線":
			result = "unwork";
			break;
		case "故障":
			result = "disabled";
			break;
		default:
			result = "other";
	}
	return result;
}

function any_series_chart_render(input_data){
	var series_array_input = [];
	if(!input_data.time_label){ input_data.time_label = 24 * 3600 * 1000 };
	if(!input_data.dashStyle){ input_data.dashStyle = [] };
	if(!input_data.rangeSelector){ input_data.rangeSelector = { enabled: false, selected: 5 } }
	input_data.data.forEach(function(element, index){
		if(!input_data.dashStyle){ input_data.dashStyle.push(0) };
		series_array_input.push({
			type: input_data.plot_type[index],
			dashStyle: input_data.dashStyle[index],
			name: input_data.series_name[index],
			color: input_data.series_color[index],
			data: element,
			tooltip: { valueDecimals: 2}
		});
	});
	var chart = Highcharts.stockChart({
		chart: {
			zoomType: 'x',
			renderTo: input_data.renderdiv,
			backgroundColor: 'white',
		},
		title: {
			text: input_data.title
		},
		rangeSelector: {
			inputEnabled: false,
			selected: input_data.rangeSelector.selected,
			enabled: input_data.rangeSelector.enabled,
			buttons: [{
				type: 'hour',
				count: 6,
				text: '6h'
			}, {
				type: 'hour',
				count: 12,
				text: '12h'
			}, {
				type: 'day',
				count: 1,
				text: '1d'
			}, {
				type: 'day',
				count: 2,
				text: '2d'
			}, {
				type: 'month',
				count: 1,
				text: '1m'
			}, {
				type: 'all',
				count: 1,
				text: 'All'
			}]
		},
		legend: {
			enabled: true
		},
		navigator: {
			enabled: false
		},
		scrollbar: {
            enabled: false
        },
		plotOptions: {
			series: {
				showInNavigator: true,
	            dataGrouping: {
	                enabled: false
	            }
			}
		},
		series: series_array_input,
        tooltip: {
			shared: true,
            xDateFormat: '%Y-%m-%d %H:%M'
        },
		xAxis: {
			dateTimeLabelFormats: {
				millisecond: '%H:%M:%S.%L',
				second: '%H:%M:%S',
				minute: '%H:%M',
				hour: '%H:%M',
				day: '%m/%e',
				week: '%e. %b',
				month: '%Y/%m',
				year: '%Y'
			},
			tickInterval: 1 * 3600 * 1000
		},
		yAxis: [{
				title: {
				text: input_data.y_title
			},
			plotBands: input_data.critical_bands,
			max: input_data.max,
			plotLines: input_data.critical_line
		}]
	})
	return chart
}

function all_series_chart_render(input_data){
	var series_array_input = [];
	input_data.data.forEach(function(element, index){
		series_array_input.push({
        	name: input_data.series_name[index],
        	data: element,
        	tooltip: { valueDecimals: 2}
		})
	});
	var plot_object = Highcharts.stockChart({
		chart: {
			type: input_data.plot_type,
			zoomType: 'x',
			renderTo: input_data.renderdiv
		},
		title: {
        	text: input_data.title
    	},
        rangeSelector: {
            selected: 5,
            buttons: [{
                type: 'hour',
                count: 6,
                text: '6h'
            }, {
                type: 'hour',
                count: 12,
                text: '12h'
            }, {
                type: 'day',
                count: 1,
                text: '1d'
            }, {
                type: 'day',
                count: 2,
                text: '2d'
            }, {
                type: 'month',
                count: 1,
                text: '1m'
            }, {
                type: 'all',
                count: 1,
                text: 'All'
            }]
        },
		legend: {
			enabled: true
		},
        plotOptions: {
            series: {
                showInNavigator: true
            }
        },
        series: series_array_input,
        yAxis: [{
            title: {
                text: input_data.y_title
            },
			plotBands: [{
                from: 0,
                to: input_data.cl_yellow,
                color: 'rgba(58, 197, 105, 0.2)'
            },{
                from: input_data.cl_yellow,
                to: input_data.cl_red,
                color: 'rgba(248, 202, 0, 0.2)'
            },{
                from: input_data.cl_red,
                to: (input_data.max+10),
                color: 'rgba(231, 29, 54, 0.2)'
            }],
            max: input_data.max,
            min: input_data.min,
            plotLines: [{
                value: input_data.cl_yellow,
                color: 'yellow',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: '黃色警戒'
                }
            },{
                value: input_data.cl_red,
                color: 'red',
                dashStyle: 'shortdash',
                width: 2,
                label: {
                    text: '紅色警戒'
                }
            }]
        }]
    })
}

function createRandomId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

// 維生管線尺寸單位mapping
function unitMapping(input) {
	switch (input) {
		case '0':
			return 'mm'
		case '1':
			return 'inch'
		case '2':
			return 'cm'
		case '3':
			return 'm'
		default:
			return ''
	}
}

// 維生管線管理單位mapping
function manageMapping(title, input) {
	const manage = {
		'瓦斯管線' : {
			"G001": "臺灣中油公司台北供氣中心",
			"G002": "中國石油公司桃園供氣中心",
			"G003": "中國石油公司液化天然氣工程處",
			"G004": "欣欣天然氣股份有限公司",
			"G005": "欣泰石油氣公司",
			"G006": "欣湖天然氣股份有限公司",
			"G007": "新海瓦斯公司",
			"G008": "陽明山瓦斯公司",
			"G009": "欣桃天然氣公司",
			"G010": "大台北瓦斯公司",
			"G011": "欣芝實業公司",
			"G012": "欣隆天然氣公司",
			"G013": "臺灣中油公司天然氣事業部苗栗營業處"
		},
		'電力管線' : {
			"E001": "台灣電力公司 台北市區營業處",
			"E002": "台灣電力公司 台北北區營業處",
			"E003": "台灣電力公司 台北南區營業處",
			"E004": "台灣電力公司 台北西區營業處",
			"E005": "台灣電力公司 基隆區營業處（甲工區）",
			"E006": "台灣電力公司 桃園區營業處",
			"E007": "台灣電力公司 台北區供電營運處",
			"E008": "台灣電力公司 新桃區供電營運處",
			"E009": "台灣電力公司 輸變電工程處 北區施工處",
			"E010": "台灣電力公司 輸變電工程處",
			"E011": "台灣電力公司 台北西區營運處（甲區）",
			"E012": "台灣電力公司 基隆區營業處（乙工區）",
			"E013": "台灣電力公司 新能源施工處",
			"E014": "台灣電力公司 再生能源處",
			"E015": "台灣電力公司 電力通信處",
			"E016": "台灣電力公司 基隆區營業處（維護組）",
			"E017": "台灣電力公司 桂山發電廠",
			"ER01": "新北市政府環境保護局",
			"ER02": "凌威風力發電股份有限公司"
		},
		'自來水管線' : {
			"WA01": "台北自來水事業處 陽明營業分處",
			"WA02": "台北自來水事業處 北區營業分處",
			"WA03": "台北自來水事業處 東區營業分處",
			"WA04": "台北自來水事業處 南區營業分處",
			"WA05": "台北自來水事業處 西區營業分處",
			"WA06": "台北自來水事業處 工程總隊",
			"WA07": "台北自來水事業處",
			"WR01": "台灣自來水公司 第十二區管理處 板橋服務所",
			"WR02": "台灣自來水公司 第十二區管理處 王城服務所",
			"WR03": "台灣自來水公司 第十二區管理處 新莊服務所",
			"WR04": "台灣自來水公司 第十二區管理處 樹林服務所",
			"WR05": "台灣自來水公司 第十二區管理處 鶯歌服務所",
			"WR06": "台灣自來水公司 第十二區管理處 蘆洲服務所",
			"WR07": "台灣自來水公司 第十二區管理處 泰山營運所",
			"WR08": "台灣自來水公司 第十二區管理處 板新給水廠",
			"WR09": "台灣自來水公司 第一區管理處 文山營運所",
			"WR10": "台灣自來水公司 第—區管理處 基隆服務所",
			"WR11": "台灣自來水公司 第—區管理處 汐止營運所",
			"WR12": "台灣自來水公司 第—區管理處 淡水營運所",
			"WR13": "台灣自來水公司 第一區管理處 瑞芳營運所",
			"WR14": "台灣自來水公司 第—區管理處 萬里金山營運所",
			"WR15": "台灣自來水公司 第—區管理處 貢寮雙溪營運所",
			"WR16": "台灣自來水公司 第一區管理處 新山給水廠",
			"WR17": "台灣自來水公司 二區管理處 林口服務所",
			"WR18": "台灣自來水公司 第十二區管理處",
			"WR19": "台灣自來水公司 北區工程處",
			"WR20": "台灣自來水公司 第二區管理處 龜山服務所",
			"WR21": "新北市五股區洲子洋自辦市地重劃會",
			"WR22": "台灣自來水公司 第二區管理處 大溪營運所",
			"WR23": "台灣自來水公司 北區工程處 第二工務所",
			"WR24": "台灣自來水公司 第—區管理處",
			"WR25": "台灣自來水公司 第二區管理處 大湳給水廠",
			"WR26": "台灣自來水公司 第二區管理處"
		},
		'輸油管線' : {
			"O100": "台灣中油股份有限公司",
			"O001": "中國石油公司台北營業處",
			"O002": "臺灣中油公司台北供氣中心",
			"O003": "中國石油公司合北處工安組",
			"O004": "台朔石化股份有限公司",
			"O005": "聯勤基隆油料大隊",
			"O006": "台灣中油公司基隆儲運處",
			"O007": "台灣中油公司資訊處電信所",
			"O008": "台灣石油公司煉製事業部桃園煉油廠",
			"O009": "淳品實業股份有限公司",
			"O010": "友亦企業股份有限公司",
			"O011": "台灣中油股份有限公司油品行銷事業部台北營業處"
		},
	}
	return manage[title][input] || " - "
}